<template>
  <div class="animated fadeIn">
    <div id="project_tiles_container">
      
      <GanttActionBar v-if="!tileView"
        :readOnly="false" 
        :allowManage="allowManage"
        :hideSecondRow="true"
        :disableEdit="true"
        :disableDelete="true"
        :disableOutdent="true"
        :disableIndent="true"
        :disableTaskCopy="true"
        :disableTaskPaste="true"
        :disableWhenMoreThanOne="true"
        
        :disableManualScheduleTask="true"
        :disableAutoScheduleTask="true"
        :disableManualScheduleProject="true"
        :disableAutoScheduleProject="true"
        :hasAutoAssignTasks="false"
  
        :dates="control.dates" 
        :startDate="control.startDate"
        :endDate="control.endDate"
        :timescale.sync="control.timescale"
        :criticalPath.sync="control.criticalPath"
        :freeFloat.sync="control.freeFloat" 
        :hideOptProjectStartToEnd="true"
        :hideOptProjectSchedule="true"
        :hideOptTaskSchedule="true"
        :hideOptProjectsSchedule="false"
        :isTemplate="false"
        @datesChanged="handleControlDates"
  
        :hideTaskOutdent="true"
        :hideTaskIndent="true"
        :hideTaskCopy="true"
        :hideTaskPaste="true"
        :hideTemplateApply="true"
        :hideTemplateSave="true"
        :hideFileImport="true"
        :hideScheduleMenu="true"
        :hideCriticalPath="true"
        :hideFreeFloat="true"
        :hideAutoAssignTasks="true"
  
        :permissionName="permissionName"
        :coloring="coloring"
  
        @startDateChanged="actionBarDateChanged($event, { isStartDate: true })"
        @endDateChanged="actionBarDateChanged($event, { isStartDate: false })"
      />
        
      <PriorityNavigation ref="list-view-toolbar" class="project-tiles grid-toolbar border" :class="{ 'border-top-0': !tileView, 'toolbar-bottom-gap': tileView }"
        :closeDropdown.sync="closePriorityNavDropdown" 
        :forceRefresh.sync="forcePriorityNavRefresh"
      >
        <li v-if="canAdd()">
          <span :id="`BTN_ADD_${id}`">
            <b-btn @click="modalOpen(true)"><font-awesome-icon :icon="['far', 'plus']" :style="{ color: 'var(--grid-toolbar-button)' }"/></b-btn>
          </span>
          <b-popover :target="`BTN_ADD_${id}`" triggers="hover" placement="top" boundary="viewport">
            {{ $t('button.add') }}
          </b-popover>
        </li>
        <li>
          <span :id="`BTN_TOGGLE_VIEW_${id}`">
            <b-btn @click="toggleTileView(true)"><font-awesome-icon :icon="['far', tileView ? 'list' : 'grid']" :style="{ color: 'var(--grid-toolbar-button)' }"/></b-btn>
          </span>
          <b-popover :target="`BTN_TOGGLE_VIEW_${id}`" triggers="hover" placement="top" boundary="viewport">
            {{ $t(tileView ? 'project.toggle_view_list' : 'project.toggle_view_grid') }}
          </b-popover>
        </li>
        <li @[filterMouseEnterEvent]="onFilterOver" @mouseleave="onFilterLeave">
          <b-dropdown v-if="!filterPinned" :id="`BTN_FILTER_${id}`" ref="filter"
            class="action-bar-dropdown text-filter" 
            toggle-class="text-decoration-none" no-caret
            @hide="onFilterTextDropdownHide"
          >
            <template #button-content>
              <font-awesome-icon :class="filterText !== '' ? 'active' : ''" :icon="['far', 'file-magnifying-glass']"/>
            </template>
            <template>
              <b-dropdown-form @submit.stop.prevent class="filter-padding">
                <b-input-group class="search-input">
                  <b-form-input v-model="filterText" @focus="filterTextFocus = true" @blur="filterTextFocus = false" :placeholder="$t('task.filter')"  @keypress.enter="onFilterSubmit"></b-form-input>
                  <b-input-group-append>
                    <b-btn :id="`BTN_CLEAR_FILTER_${id}`" @click="onFilterClear" class="search-append search-append-bg" size="sm"><font-awesome-icon :icon="['far', 'xmark']"/></b-btn>
                    <b-popover :target="`BTN_CLEAR_FILTER_${id}`" triggers="hover" placement="top">
                      {{ $t('button.clear') }}
                    </b-popover>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn :id="`BTN_SEARCH_FILTER_${id}`" @click="onFilterSubmit" class="search-append search-append-bg" size="sm"><font-awesome-icon :icon="['far', 'magnifying-glass']"/></b-btn>
                    <b-popover :target="`BTN_SEARCH_FILTER_${id}`" triggers="hover" placement="top">
                      {{ $t('button.search') }}
                    </b-popover>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn :id="`BTN_PIN_FILTER_${id}`" @click="onPinFilter" class="search-append search-append-bg" size="sm"><font-awesome-icon :icon="['far', 'thumbtack']"/></b-btn>
                    <b-popover :target="`BTN_PIN_FILTER_${id}`" triggers="hover" placement="top">
                      {{ $t('button.pinOnToolbar') }}
                    </b-popover>
                  </b-input-group-append>
                </b-input-group>
              </b-dropdown-form>
            </template>
          </b-dropdown>
        </li>
        <li>
          <b-input-group class="search-input" v-if="filterPinned">
            <b-form-input v-model="filterText" @focus="filterTextFocus = true" @blur="filterTextFocus = false" :placeholder="$t('task.filter')"  @keypress.enter="onFilterSubmit"></b-form-input>
            <b-input-group-append>
              <b-btn :id="`BTN_CLEAR_FILTER_${id}`" @click="onFilterClear" class="search-append search-append-bg" size="sm"><font-awesome-icon :icon="['far', 'xmark']"/></b-btn>
              <b-popover :target="`BTN_CLEAR_FILTER_${id}`" triggers="hover" placement="top">
                {{ $t('button.clear') }}
              </b-popover>
            </b-input-group-append>
            <b-input-group-append>
              <b-btn :id="`BTN_SEARCH_FILTER_${id}`" @click="onFilterSubmit" class="search-append search-append-bg" size="sm"><font-awesome-icon :icon="['far', 'magnifying-glass']"/></b-btn>
              <b-popover :target="`BTN_SEARCH_FILTER_${id}`" triggers="hover" placement="top">
                {{ $t('button.search') }}
              </b-popover>
            </b-input-group-append>
            <b-input-group-append>
              <b-btn :id="`BTN_UNPIN_FILTER_${id}`" @click="onUnPinFilter" class="search-append search-append-bg" size="sm"><font-awesome-icon :icon="['far', 'thumbtack']"/></b-btn>
              <b-popover :target="`BTN_UNPIN_FILTER_${id}`" triggers="hover" placement="top">
                {{ $t('button.unpinFromToolbar') }}
              </b-popover>
            </b-input-group-append>
          </b-input-group>
        </li>
        <li @[badgeFilterMouseEnterEvent]="onBadgeFilterEnter" 
            @[badgeFilterMouseOverEvent]="onBadgeFilterOver" 
            @[badgeFilterMouseLeaveEvent]="onBadgeFilterLeave" 
            @[badgeFilterTouchEndEvent]="onBadgeFilterOver">
          <b-dropdown v-if="!badgeFilterPinned" :id="`BTN_BADGE_FILTER_${id}`" ref="badgeFilter"
            class="action-bar-dropdown text-filter" 
            toggle-class="text-decoration-none" no-caret
            @hide="onBadgeFilterDropdownHide"
          >
            <template #button-content>
              <font-awesome-icon :class="badgeFilters.length > 0 ? 'active' : ''" :icon="['far', 'filter']"/>
            </template>
            <template>
              <b-dropdown-form @submit.stop.prevent class="filter-padding">
                <TaskViewBadgeFilter :filters="badgeFilters" 
                  :fields="badgeFilterFields" 
                  :fieldValues="badgeFilterFieldValues"
                  :useLink="false"
                  :data="filter"
                  :hideAdvanced="false"
                  canPin 
                  @modified="onBadgeFilterModified" 
                  @advModified="onAdvFilterModified"
                  @filterModalOpened="onBadgeFilterModalOpened"
                  @filterModalClosed="onBadgeFilterModalClosed"
                  @fetchFieldOptions="onBadgeFilterFetchOptions"
                  @pin="onPinBadgeFilter"
                  />
              </b-dropdown-form>
            </template>
          </b-dropdown>
        </li>
        <li>
          <TaskViewBadgeFilter v-if="badgeFilterPinned"
            :filters="badgeFilters" 
            :fields="badgeFilterFields" 
            :fieldValues="badgeFilterFieldValues" 
            :data="filter"
            :hideAdvanced="false"
            canPin
            pinned
            @modified="onBadgeFilterModified"  
            @advModified="onAdvFilterModified"
            @filterModalOpened="onBadgeFilterModalOpened"
            @filterModalClosed="onBadgeFilterModalClosed"
            @fetchFieldOptions="onBadgeFilterFetchOptions"
            @pin="onUnPinBadgeFilter"
            />
        </li>
        <li class="view" @[viewMouseEnterEvent]="onViewOver" @mouseleave="onViewLeave">
          <b-dropdown :id="`BTN_VIEW_${id}`" ref="view" class="action-bar-dropdown" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <font-awesome-icon :icon="['far','desktop']"/>
            </template>
            
              <b-dropdown-item @click="savePreset" href="#">
                <span class="action-item-label">{{ $t('task.button.save') }}</span>
              </b-dropdown-item>
              <b-dropdown-divider/>
              <template v-for="(item, index) in projectViews">
                <b-dropdown-item class="action-item" @click="loadViewSettings(item)" href="#" :key="index">
                  <span :id="`viewname${index}`" class="action-item-label-with-icon">{{ item.name }}</span>
                  <b-popover
                    v-if="isEllipsisActive(item.name)"
                    :target="`viewname${index}`"
                    placement="top"
                    boundary="viewport"
                    custom-class="popover-margin"
                    triggers="hover"
                    offset="-100"
                    :content="item.name">
                  </b-popover> 
                  <span>
                    <template v-if="!editPermission(item)">
                      <span class="action-item-icon"
                          :id="`COPY_COLUMN_${index}`"
                          @click.stop.prevent="copyColumnSettings(item.name, item)">
                        <font-awesome-icon class="" :icon="['far','copy']"/>
                      </span>
                      <b-popover :target="`COPY_COLUMN_${index}`" triggers="hover" placement="top" boundary="viewport">
                        {{ $t('task.button.copy') }}
                      </b-popover>
                      <span class="action-item-icon position-third" 
                          @[infoMouseEnterEvent]="onInfoOver(index)" @mouseleave="onInfoLeave(index)"
                          :id="`BTN_INFO_${index}`">
                        <font-awesome-icon class="" :icon="['far','circle-info']"/>
                      </span>
                      <b-popover
                        :target="`BTN_INFO_${index}`"
                        :ref="`BTN_INFO_${index}`"
                        :show.sync="showInfo[index]"
                        placement="top"
                        boundary="viewport"
                        triggers="manual"
                        :content="$t('owner', [projectViews[index].owner])">
                      </b-popover>
                    </template>
                    <template v-if="editPermission(item)">
                      <span class="action-item-icon position-third"
                          :id="`SHARE_COLUMN_${index}`"
                          @click.stop.prevent="shareColumnSettings(index, item.name, item)">
                        <font-awesome-icon class="" :icon="[item.defaultView ? 'fas' : 'far','share-nodes']"/>
                      </span>
                      <b-popover :target="`SHARE_COLUMN_${index}`" triggers="hover" placement="top" boundary="viewport">
                        {{ $t('task.button.share') }}
                      </b-popover>
                    </template>
                    <template v-if="editPermission(item)">
                      <span class="action-item-icon position-second" 
                          :id="`UPDATE_COLUMN_${index}`"
                          @click.stop.prevent="updateColumnSettings(index, item.name, item)">
                        <font-awesome-icon class="" :icon="['far', 'floppy-disk']"/>
                      </span>
                      <b-popover :target="`UPDATE_COLUMN_${index}`" triggers="hover" placement="top" boundary="viewport">
                        {{ $t('task.button.update') }}
                      </b-popover>
                    </template>
                    <template v-if="editPermission(item)">
                      <span class="action-item-icon"
                          :id="`REMOVE_COLUMN_${index}`"
                          @click.stop.prevent="removeColumnSettings(index)">
                        <font-awesome-icon class="" :icon="['far', 'trash-can']"/>
                      </span>
                      <b-popover :target="`REMOVE_COLUMN_${index}`" triggers="hover" placement="top" boundary="viewport">
                        {{ $t('task.button.delete') }}
                      </b-popover>
                    </template>
                  </span>
                </b-dropdown-item>
              </template>
            
          </b-dropdown>
        </li>
        <li @[colorMouseEnterEvent]="onColoringOver" @mouseleave="onColoringLeave">
          <b-dropdown :id="`BTN_COLORING_PROJECT_TILES`" ref="coloring" class="no-left-padding coloring-btn action-bar-dropdown" 
            toggle-class="text-decoration-none" no-caret
          >
            <template #button-content>
              <font-awesome-icon :icon="['far', 'palette']"/>
            </template>
            <b-dropdown-group :header="$t('colorby')">
              <b-dropdown-item @click="onColorChange('none')" href="#">
                <span class="action-item-label">{{ $t('none') }}</span><font-awesome-icon class="active-check" v-if="coloring.none" :icon="['far', 'check']"/>
              </b-dropdown-item>
              <b-dropdown-item @click="onColorChange('project')" href="#">
                <span class="action-item-label">{{ $t('project.coloring.project') }}</span><font-awesome-icon class="active-check" v-if="coloring.project" :icon="['far', 'check']"/>
              </b-dropdown-item>
              <b-dropdown-item @click="onColorChange('company')" href="#">
                <span class="action-item-label">{{ $t('company.coloring.company') }}</span><font-awesome-icon class="active-check" v-if="coloring.company" :icon="['far', 'check']"/>
              </b-dropdown-item>
              <b-dropdown-item @click="onColorChange('location')" href="#">
                <span class="action-item-label">{{ $t('project.coloring.location') }}</span><font-awesome-icon class="active-check" v-if="coloring.location" :icon="['far', 'check']"/>
              </b-dropdown-item>
              <b-dropdown-item @click="onColorChange('customer')" href="#">
                <span class="action-item-label">{{ $t('project.coloring.customer') }}</span><font-awesome-icon class="active-check" v-if="coloring.customer" :icon="['far', 'check']"/>
              </b-dropdown-item>
              <b-dropdown-item @click="onColorChange('status')" href="#">
                <span class="action-item-label">{{ $t('project.coloring.status') }}</span><font-awesome-icon class="active-check" v-if="coloring.status" :icon="['far', 'check']"/>
              </b-dropdown-item>
              <b-dropdown-item @click="onColorChange('rebate')" href="#">
                <span class="action-item-label">{{ $t('project.coloring.rebate') }}</span><font-awesome-icon class="active-check" v-if="coloring.rebate" :icon="['far', 'check']"/>
              </b-dropdown-item>
            </b-dropdown-group>
          </b-dropdown>
        </li>
        <li v-if="tileView">
          <span>
            <b-btn :pressed.sync="allProjectsExpanded" id="project-list-switch" class="filter-button btn-secondary" name="project-list-switch " @click="onExpand">
              <font-awesome-icon :icon="['far', allProjectsExpanded ? 'eye-slash' : 'eye']" :style="{ color: 'var(--grid-toolbar-button)' }"/>
            </b-btn>
          </span>
          <b-popover
            target="project-list-switch"
            placement="top"
            triggers="hover"
            :content="$t(allProjectsExpanded ? 'project.settings.hide' : 'project.settings.show')">
          </b-popover>
        </li>
        <li @[displaySettingsMouseEnterEvent]="onDisplaySettingsOver" @mouseleave="onDisplaySettingsLeave">
          <b-dropdown :id="`BTN_DISPLAY_SETTINGS_${id}`" ref="project-tiles-display-settings" no-caret class="display-settings action-bar-dropdown" toggle-class="text-decoration-none">
            <template #button-content>
              <font-awesome-icon :icon="['far', 'list-check']"/>
            </template>
            
            <b-dropdown-group v-if="tileView" :header="$t('project.display.title')">
              <template v-for="(item, key) in display">
                  <div :key="key" class="dropdown-item progress-toggle" @click.prevent>
                    <b-form-checkbox v-model="display[key]" @click.native="toggleVisible(key)">{{displayLabels[key]}}</b-form-checkbox>
                  </div>
              </template>
            </b-dropdown-group>
            
            <b-dropdown-group :header="$t('project.progress.title')">
              <div v-if="canView('PROJECT', ['progress'])" class="dropdown-item progress-toggle" @click.prevent>
                <b-form-checkbox v-model="progressFilters['_progress0']" @click.native="toggleProgressFilter('_progress0')">
                  <span class='legend-item project-tile-0'></span>
                  <span>0%</span>
                </b-form-checkbox>
              </div>
              <div v-if="canView('PROJECT', ['progress'])" class="dropdown-item progress-toggle" @click.prevent>
                <b-form-checkbox v-model="progressFilters['_progress25']" @click.native="toggleProgressFilter('_progress25')">
                  <span class='legend-item project-tile-25'></span>
                  <span>1% - 25%</span>
                </b-form-checkbox>
              </div>
              <div v-if="canView('PROJECT', ['progress'])" class="dropdown-item progress-toggle" @click.prevent>
                <b-form-checkbox v-model="progressFilters['_progress50']" @click.native="toggleProgressFilter('_progress50')">
                  <span class='legend-item project-tile-50'></span>
                  <span>26% - 50%</span>
                </b-form-checkbox>
              </div>
              <div v-if="canView('PROJECT', ['progress'])" class="dropdown-item progress-toggle" @click.prevent>
                <b-form-checkbox v-model="progressFilters['_progress75']" @click.native="toggleProgressFilter('_progress75')">
                  <span class='legend-item project-tile-75'></span>
                  <span>51% - 75%</span>
                </b-form-checkbox>
              </div>
              <div v-if="canView('PROJECT', ['progress'])" class="dropdown-item progress-toggle" @click.prevent>
                <b-form-checkbox v-model="progressFilters['_progress99']" @click.native="toggleProgressFilter('_progress99')">
                  <span class='legend-item project-tile-99'></span>
                  <span>76% - 99%</span>
                </b-form-checkbox>
              </div>
              <div v-if="canView('PROJECT', ['progress'])" class="dropdown-item progress-toggle" @click.prevent>
                <b-form-checkbox v-model="progressFilters['_progress100']" @click.native="toggleProgressFilter('_progress100')">
                  <span class='legend-item project-tile-100'></span>
                  <span>100%</span>
                </b-form-checkbox>
              </div>
            </b-dropdown-group>
          </b-dropdown>
          <b-popover
            :target="`BTN_DISPLAY_SETTINGS_${id}`"
            placement="top"
            triggers="hover"
            :content="$t('project.settings.display')">
          </b-popover>
        </li>
      </PriorityNavigation>
      
      <template v-if="tileView">
        <div class="loading" v-if="loadingFav">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <b-row v-if="filteredFavProjects().length > 0" class="fav-background">
            <template v-for="project in favProjects">
               <div :key="`fav${project.uuId}_${JSON.stringify(coloring)}`" :class="projectClass(project.progress)" :style="projectStyle(project)" v-show="shouldDisplay(project)">
                <a v-on:click="projectId = project.uuId; renderPopup($event)" class="link">
                  <ProjectTile :project="project" :coloring="coloring" :display="display" :favourite="true" @toggleFavourite="toggleFavourite"/>
                   <div class="project-title" :style="projectStyle(project)">{{ project.name }}</div>
                </a>
               </div>
            </template>
          </b-row>
        </div>
        
        <div v-if="!allProjectsExpanded" class="hidden-message">
          <div class="hidden-message-text">{{ $t('project.list_hidden') }}</div>
          <font-awesome-icon :icon="['far','eye-slash']"/>
        </div>
               
        <b-collapse id="collapse-4" v-model="allProjectsExpanded" class="project-list mt-2">
          <div class="loading" v-if="loading">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <b-row>
              <template v-for="(projects, index) in projectBatch">
              <template v-if="defer(index)">
              <template v-for="project in projects">
                 <div :key="`${project.uuId}_${JSON.stringify(coloring)}`" :class="projectClass(project.progress)" :style="projectStyle(project)" v-show="shouldDisplay(project) && !project.favourite">
                  <a v-on:click="projectId = project.uuId; renderPopup($event)" class="link">
                    <ProjectTile :project="project" :coloring="coloring" :display="display" :searchFilter="searchFilter" @toggleFavourite="toggleFavourite" :forceRender.sync="project.forceRender"/>
                     <div class="project-title" :style="projectStyle(project)">{{ project.name }}</div>
                  </a>
                 </div>
              </template>
              </template>
              </template>
            </b-row>
          </div>
        </b-collapse>
      </template>
      <!-- <div v-else> -->
        <div v-else class="splitter-container" ref="splitter-container" :style="splitterStyle">
          <div class="lhs-grid" ref="lhs-grid">
            <ag-grid-vue :style="lhsGridStyle" class="ag-theme-balham projectlist-grid-height" id="pt-grid"
              :gridOptions="gridOptions"
              @grid-ready="onGridReady"
              :columnDefs="columnDefs"
              :context="context"
              :defaultColDef="defaultColDef"
              :getRowId="params => params.data.uuId"
              noRowsOverlayComponent="noRowsOverlay"
              :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
              :overlayLoadingTemplate="overlayLoadingTemplate"
              :cacheBlockSize="10000"
              :rowData="rowData"
              rowModelType="serverSide"
              
              :rowMultiSelectWithClick="false"
              rowSelection="multiple"
              :serverSideInfiniteScroll="true"
              :headerHeight="35"
              :sideBar="false"
              suppressDragLeaveHidesColumns
              suppressContextMenu
              :suppressCellFocus="false"
              :suppressMultiSort="false"
              :singleClickEdit="false"
              :enableRangeSelection="true"
              :rowHeight="33"
              alwaysShowHorizontalScroll
              >
          </ag-grid-vue>
          </div>
          <div class="resizer" ref="resizer" id="grid-gantt-resizer" @mousedown="mouseDownHandler">
            <div class="resizer-overlay" ref="resizer-overlay" id="resizer-overlay">
              <font-awesome-icon class="resizer-icon" :icon="['far', 'arrows-left-right']"/>
            </div>
          </div>
    
          <!-- Gantt Chart -->
          <div class="rhs-chart" ref="rhs-chart" style="overflow: hidden">
            <DhtmlxGantt useCase="project-tiles"
              :scrollY="scrollState.top"
              :scrollX.sync="scrollState.left"
              :height="ganttHeight"
              :router="routerObj"
              :ganttData="ganttData"
              :startDate="control.startDate"
              :endDate="control.endDate"
              :timescale="control.timescale"
              :criticalPath="control.criticalPath"
              :freeFloat="control.freeFloat"
              :markerStartText="marker.projectStart"
              :markerEndText="marker.projectEnd"
              :markerTodayText="marker.today"          
              :pendingRerender.sync="pendingRerender"
              :heightOffset="230"
              :rowHeight="33"
              :scaleHeight="36"
              :showPadlock="false"
              :defaultColoring="coloring.none"
              @ganttScroll="ganttScrollHandler"
              @ganttCreated="createdGantt"
              @taskSelectionChanged="taskSelectionChangedHandler"
              @taskClicked="taskClickedHandler"
              @cellFocused="taskCellFocusedHandler"
              
              :showMarkerStartText="marker.showStartText"
              :showMarkerEndText="marker.showEndText"
              :showMarkerTodayText="marker.showTodayText"
              @markerChangedStart="markerStateHandler($event, 'showStartText')"
              @markerChangedEnd="markerStateHandler($event, 'showEndText')"
              @markerChangedToday="markerStateHandler($event, 'showTodayText')"
    
              :collapseId="collapseId"
              :expandId="expandId"
              :selectedTasks="taskSelectionIds"
              :collapseIds="collapseIds"
              :expandIds="expandIds"
              @progress-complete="progressComplete"
    
              :readOnly="true"
              
              :filteredIds="filteredIds"
              :applyGanttMarker.sync="signalApplyGanttMarker"
            />
          </div>
        </div>
          
      <!-- </div> -->
    </div>
    
    <ProjectModal v-if="projectShow" :id="projectId" :readOnly="!canEdit('PROJECT', [], projectId)" :show.sync="projectShow" @success="projectSuccess" :title="projectTitle"/>
    
    <SaveViewModal :show.sync="promptSaveShow" :name="saveName" :title="$t('task.confirmation.save')" :profile="saveProfile" @ok="confirmSaveOk"/>
    <SaveViewModal :show.sync="promptShareShow" :name="saveName" :title="$t('task.confirmation.share')" :sharing="true" :profile="saveProfile" @ok="confirmSaveOk"/> 
   
   <b-modal :title="$t('task.confirmation.title_delete')"
        v-model="confirmDeleteViewShow"
        @ok="confirmDeleteViewOk"
        content-class="shadow"
        no-close-on-backdrop
        >
      <div class="d-block">
        {{ $t('task.confirmation.delete_view') }}
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="success" @click="ok()">{{ $t('button.confirm') }}</b-button>
        <b-button size="sm" variant="danger" @click="cancel()">{{ $t('button.cancel') }}</b-button>
      </template>
    </b-modal>
    
  </div>
</template>

<script>
import Vue from 'vue';
import { cloneDeep, debounce } from 'lodash';
import * as moment from 'moment-timezone';
moment.tz.setDefault('Etc/UTC');
const locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
moment.locale(locale);
import { getCustomFieldInfo, prepareCustomFieldColumnDef } from '@/helpers/custom-fields'
import { companyService, projectService, projectProfileService, viewProfileService, profileService } from "@/services";
import ProjectTile from "@/components/Project/ProjectTile";
import DhtmlxGantt from '@/components/Gantt/DhtmlxGanttWithNoGrid';
import { transformField, buildFilter, getFieldType, invertColor, getFirstColor, toComplimentary, objectClone, isEllipsisActive } from '@/helpers';
import 'ag-grid-enterprise';
import { AgGridVue } from 'ag-grid-vue';

import { TRIGGERS, convertDurationToDisplay, extractDurationConversionOpts
, calcDateTimeDurationv2 } from '@/helpers/task-duration-process';
import { filterOutViewDenyProperties, columnDefSortFunc } from '@/views/management/script/common'
import alertStateEnum from '@/enums/alert-state';
import { strRandom } from '@/helpers';

import { projectUtil } from '@/views/management/script/project'

import DetailLinkCellRenderer from '@/components/Aggrid/CellRenderer/DetailLink';
import DateTimeCellRenderer from '@/components/Aggrid/CellRenderer/DateTime';
import RebateCellRenderer from '@/components/Aggrid/CellRenderer/Rebate';
import CostCellRenderer from '@/components/Aggrid/CellRenderer/Cost';
import DurationCellRenderer from '@/components/Aggrid/CellRenderer/Duration';
import ColorCellRenderer from '@/components/Aggrid/CellRenderer/Color';
import NoRowsOverlay from '@/components/Aggrid/Overlay/NoRows';
import PercentageCellRenderer from '@/components/Aggrid/CellRenderer/Percentage';
import PriorityNavigation from '@/components/PriorityNavigation/PriorityNavigation';
import GenericObjectCellRenderer from '@/components/Aggrid/CellRenderer/GenericObject'
import GenericEntityArrayCellRenderer from '@/components/Aggrid/CellRenderer/GenericEntityArray'
import GenericCellRenderer from '@/components/Aggrid/CellRenderer/Generic'

function createGanttData(self, data) {
  const copyData = cloneDeep(data);
  for (let i = 0; i < copyData.length; i++) {
    const p = copyData[i];
    p.id = p.uuId;
    p.text = p.name;
    p.projectColor = p.color;
    delete p.color;
    p.start_date = moment(p.scheduleStart).format('YYYY-MM-DD');
    p.end_date = moment(p.scheduleFinish).format('YYYY-MM-DD');
    p.durationInDays = p.estimatedDuration / 8;
    p.type = 3;
    copyData[i] = self.setGanttColors(p);
  }
  return copyData;
}

function ServerSideDatasource(self) {
  return {
    getRows(params) {
      const p = self.buildParams(params);
      if(self.isFirstLoad && self.selectedId != null) {
        p.sight = self.selectedId;
      }
      projectService.listv2(p, self.customFields, { includeProgress: true, includeCalculation: true }).then((response) => {

        // filter the projects by progress
        const data = [];
        for (const p of response.data) {
          if (self.shouldDisplay(p)) {
            data.push(p);
          }
        }
        
        self.totalRecords = response.arg_total;
        params.success({ rowData: data, rowCount: data.length });
        
        if (self.searchFilter !== '' ||
            data.length !== response.data.length) {
          self.filteredIds = data.map(d => d.uuId);
        }
        else {
          self.filteredIds = null;
        }
           
           self.gantt.clearAll();
        self.gantt.parse({
          data:createGanttData(self, data),
          links:[]
        });  
         
        self.signalApplyGanttMarker = true;
        if (self.control.dates === 'projects-schedule') {
          self.handleControlDates('projects-schedule');
        }
        
        self.gridApi.hideOverlay();
      })
      .catch(() => {
        params.success({ rowData: [], rowCount: 0 });
      });
    }
  }
}

const getColumnDefs = (c) => {
  return {
    colId: c.colId
    , width: c.actualWidth
    , sort: c.sort != null? c.sort : null
    , sortIndex: c.sortIndex != null? c.sortIndex : null
  }
}
    
function sortFunc(a, b) {
  const order = "asc";
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return order === "asc" ? -1 : 1;
  }
  else if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return order === "asc" ? 1 : -1;
  }
  return 0;
}

import Defer from "@/mixins/defer";

export default {
  name: "ProjectTiles",
  components: {
    'ag-grid-vue': AgGridVue,
    ProjectModal: () => import('@/components/modal/ProjectModal.vue'),
    ProjectTile,
    SaveViewModal: () => import('@/components/modal/SaveViewModal.vue'),
    DhtmlxGantt,
    GanttActionBar: () => import('@/components/Gantt/components/AgGridGanttActionBar'),
    TaskViewBadgeFilter: () => import('@/components/Filter/TaskViewBadgeFilter.vue'),
    
    PriorityNavigation,
    //aggrid cell renderer/editor/header component
    /* eslint-disable vue/no-unused-components */
    'detailLinkCellRenderer': DetailLinkCellRenderer,
    'dateTimeCellRenderer': DateTimeCellRenderer,
    'rebateCellRenderer': RebateCellRenderer,
    'costCellRenderer': CostCellRenderer,
    'durationCellRenderer': DurationCellRenderer,
    'colorCellRenderer': ColorCellRenderer,
    'genericObjectCellRenderer': GenericObjectCellRenderer,
    'genericCellRenderer': GenericCellRenderer,
    'genericEntityArrayCellRenderer': GenericEntityArrayCellRenderer,
    'percentageCellRenderer': PercentageCellRenderer, 
    //Overlay
    noRowsOverlay: NoRowsOverlay
    /* eslint-enable vue/no-unused-components */ 
  },
  mixins: [
    Defer()
  ],
  data() {
    return {
      permissionName: 'PROJECT',
      userId: null,
      loading: false,
      loadingFav: false,
      searchFilter: '',
      favProjects: [],
      projects: [],
      projectOrder: {},
      profiles: {},
      filterShow: false,
      filter: null,
 
      //BadgeFilter related
      badgeFilters: [
        // { field: 'taskName', name: 'Task Name: Task #1, Task #2', value: [{ checked: true, text: 'Task #1'}, { checked: true, text: 'Task #2'}] }
        // , { field: 'skillName', name: 'Skill Name: Rigging, Animation', value: [{ checked: true, text: 'Rigging'}, { checked: true, text: 'Animation'}] }
      ], 
      badgeFilterFields: [      
        { value: 'closeTime', text: 'Finish Date' }  
        , { value: 'description', text: 'Description' }
        , { value: 'identifier', text: 'Identifier' }        
        , { value: 'priority', text: 'Priority' }
        , { value: 'progress', text: 'Progress' }  
        , { value: 'rebateName', text: 'Rebate Name' }
        , { value: 'stageName', text: 'Stage Name' }        
        , { value: 'startTime', text: 'Start Date' }    
        , { value: 'tagName', text: 'Tag Name' }
        , { value: 'name', text: 'Project Name' }
      ], 
      badgeFilterFieldValues: {
        // taskName: [
        //   { text: 'Task #1' }
        //   , { text: 'Task #2' }
        // ],
        // skillName: [
        //   { text: 'Rigging' },
        //   { text: 'Layout' },
        //   { text: 'Animation' }
        // ]
      }, 
      badgeFilterOptionFetchFunc: null,
      badgeFilterFocus: false, 
      badgeFilterModalOpened: 'close', 
      badgeFilterPinned: false, 
      
      filterText: '',
      filterTextFocus: false,
      filterPinned: false,
      closePriorityNavDropdown: false,
      forcePriorityNavRefresh: false,

      schema: null,
      macros: null,
      display: {
        avatar: true,
        banner: true,
        progress: true,
        dates: true,
        cost: true,
        duration: true,
        status: true
      },
      displayLabels: {
        avatar: this.$i18n.t("project.display.avatar"),
        banner: this.$i18n.t("project.display.banner"),
        progress: this.$i18n.t("project.display.progress"),
        dates: this.$i18n.t("project.display.dates"),
        cost: this.$i18n.t("project.display.cost"),
        duration: this.$i18n.t("project.display.duration"),
        status: this.$i18n.t("project.display.status")
      },
      progressFilters: {
        _progress0: true,
        _progress25: true,
        _progress50: true,
        _progress75: true,
        _progress99: true,
        _progress100: true
      },
      allProjectsExpanded: true,
      projectBatch: [],
      
      // views
      promptSaveShow: false,
      promptShareShow: false,
      saveName: null,
      saveProfile: null,
      saveIndex: -1,
      confirmDeleteViewShow: false,
      deleteViewIndex: -1,
      projectViews: [],
      
      coloring: {
        none: true,
        project: false,
        company: false,
        location: false,
        customer: false,
        status: false,
        rebate: false
      },
      
      tileView: true,
      gridOptions: null,
      gridApi: null,
      api: null,
      columnDefs: [],
      context: null,
      defaultColDef: null,
      rowData: null,
      allowManage: true,
      projectId: null,
      projectShow: false,
      
      lastOpenColumnMenuParams: null,

      noRowsMessage: null,
      noRowsOverlayComponentParams: null,
      multiple: true,
      
      splitterStyle: {}, 
      lhsGridStyle: {},
      
      //Start Scroll state
      scrollState: {
        left: -1
        , top: -1
        , triggeredByLHSGrid: false
        , triggeredByRHSChart: false
      },
      //End Scroll state
      ganttHeight: -1, 
      ganttData: {
        data: []
      }, 
      gantt: null, 
      pendingRerender: false,
      
      control: {
        dates: 'this-year'
        , startDate: null
        , endDate: null
        , timescale: 'year'
        , criticalPath: false
        , freeFloat: false
      },
      marker: {
        showStartText: false
        , showEndText: false
        , showTodayText: true
      },
      
      splitterEventState: {
        isMouseDown: false
        , x: 0
        , y: 0
        , leftWidth: 0
      },
      
      // Variables to signal gantt to collapse/expand a branch
      collapseId: null, 
      expandId: null, 
      collapseIds: null, 
      expandIds: null,
      
      filteredIds: null,
      taskSelectionIds: [],
      showInfo: [],
      customFields: [],
      durationConversionOpts: {}, 
      signalApplyGanttMarker: false
    };
  },
  created() {
    this.id = strRandom(8);
    this.getDurationConversionOpts();
    this.$store.dispatch('data/info', { type: 'model' }).then((value) => { 
      this.schema = value;
    })
    .catch(e => {
      console.error(e); // eslint-disable-line no-console
    });
        
    //Declare properties that do not need value changing observer.
    this.resizerWidth = 5;
    this.touchEvent = {
      isTouchStart: false
      , x: 0
      , leftWidth: 0
    }
    
    this.debouncedTouchMoveHandler = debounce(this.touchMoveHandler, 10);
    
    this.$store.dispatch('data/info', { type: 'macro' }).then((value) => { 
      this.macros = value;
    })
    .catch(e => {
      console.error(e); // eslint-disable-line no-console
    });
    // get the user id
    this.userId = this.$store.state.authentication.user.uuId;

    this.loadProfiles();
    
    if (!this.canView('PROJECT', ['scheduleStart', 'scheduleFinish'])) {
      delete this.display.dates;
    }
    
    if (!this.canView('PROJECT', ['progress'])) {
      delete this.display.progress;
    }
    
    if (!this.canView('STAGE')) {
      delete this.display.status;
    }
    
    if (!this.canView('PROJECT', ['avatarRef'])) {
      delete this.display.avatar;
    }
    
    if (!this.canView('PROJECT', ['bannerRef'])) {
      delete this.display.banner;
    }
    
    if (!this.canView('PROJECT', [
        'actualCost',
        'actualCostNet',
        'estimatedCost',
        'estimatedCostNet',
        'plannedCost',
        'fixedCost', 
        'fixedCostNet', 
        'totalFixedCost', 
        'totalFixedCostNet'
      ])) {
      delete this.display.cost;
    }
    
    if (!this.canView('PROJECT', [
        'actualDuration',
        'estimatedDuration',
        'plannedDuration'
      ])) {
      delete this.display.duration;
    }
    
  
    //BadgeFilter related

    if (Object.hasOwn(projectUtil, 'getBadgeFilterOptionFetchFunc')) {
      this.badgeFilterOptionFetchFunc = projectUtil.getBadgeFilterOptionFetchFunc(this)
      this.badgeFilterFields = projectUtil.getBadgeFilterFields(this)
    }
    //Empty the value. New data will be fetched when needed
    if (Object.keys(this.badgeFilterFieldValues).length > 0) {
      this.badgeFilterFieldValues = {}
    }
    this.initSingleBadgeFilterValues();
  
    this.handleControlDates('this-month');
  },
  mounted() {
    this.chartResizeHandler();
    window.addEventListener('resize', this.chartResizeHandler);
    
    //BadgeFilter related
    document.addEventListener('click', this.toggleBadgeFilterFocus);
    document.addEventListener('keydown', this.handleBadgeFilterEscapeKeyDown)
    
    //A trick tor wait until the resizer-overlay element gets ready
    const interval = setInterval(() => {
      const resizerOverlayElem = this.$refs['resizer-overlay'];
      if (resizerOverlayElem) {
        if(this.isTouchDevice()) {
          this.$refs['resizer-overlay'].addEventListener('touchstart', this.touchStartHandler);
        } else {
          this.$refs['resizer-overlay'].style.display = 'none';
        }    
        clearInterval(interval);
      }
    }, 50);
  },
  beforeDestroy() {
    //BadgeFilter related
    document.removeEventListener('keydown', this.handleBadgeFilterEscapeKeyDown)
    document.removeEventListener('click', this.toggleBadgeFilterFocus);
    this.badgeFilterFocus = false;
    this.badgeFilterModalOpened = 'close';
    
    window.removeEventListener('resize', this.chartResizeHandler);
    if (this.$refs['resizer-overlay']) {
      this.$refs['resizer-overlay'].removeEventListener('touchstart', this.touchStartHandler);
      this.$refs['resizer-overlay'].removeEventListener('touchmove', this.debouncedTouchMoveHandler);
      this.$refs['resizer-overlay'].removeEventListener('touchcancel', this.touchCancelHandler);
      this.$refs['resizer-overlay'].removeEventListener('touchend', this.touchEndHandler);
    }
    this.gridApi = null;
  }, 
  computed: {
    filterMouseEnterEvent() {
      return this.isTouchDevice()? null : 'mouseenter';
    },
    infoMouseEnterEvent() {
      return this.isTouchDevice()? null : 'mouseenter';
    },
    badgeFilterMouseEnterEvent() {
      return this.isTouchDevice()? null : 'mouseenter';
    },
    badgeFilterMouseOverEvent() {
      return this.isTouchDevice()? null : 'mouseover';
    },
    badgeFilterMouseLeaveEvent() {
      return this.isTouchDevice()? null : 'mouseleave';
    },
    badgeFilterTouchEndEvent() {
      return this.isTouchDevice()? 'touchend' : null;
    },
    projectTitle() {
      return this.projectId && this.projectId.indexOf('PROJECT_NEW') == -1? this.$t('project.title_detail'): this.$t('project.title_new');
    },
    overlayLoadingTemplate() {
      return `<span class='grid-overlay'><div class="mr-1 spinner-grow spinner-grow-sm text-dark"></div>${ this.$t('dataview.grid.loading') }</span>`;
    },
    routerObj() {
      const linkService = null;
      // eslint-disable-next-line
      return function({ g, self } = {}) {
        return {
          task: {
            update: debounce(function(data, id) {
            
              if (!data.dragMode) {
                return; // we have updated the task with new data from the server
              }
              
              const oldStartDateTime = moment.utc(data.orgStartDate);
              const oldCloseDateTime = moment.utc(data.orgEndDate);
              let startTime = moment.utc(data.start_date);
              let closeTime = moment.utc(data.end_date);
              
              //Stop proceed further when startTime and closeTime have no change.
              if (data.dragMode != 'progress' && oldStartDateTime.format('YYYY-MM-DD HH:mm') == startTime.format('YYYY-MM-DD HH:mm') 
                  && oldCloseDateTime.format('YYYY-MM-DD HH:mm') == closeTime.format('YYYY-MM-DD HH:mm')) {
                return Promise.resolve({ 'action': 'updated' });
              }
              
              let constraintDate = null;
              if (data.constraint_date != null) {
                constraintDate = moment.utc(data.constraint_date);
              }
              
              let durationDisplay = convertDurationToDisplay(data.orgDuration, data.durationAUM, self.durationConversionOpts);
              let dragMode = 'move';
              if (data.dragMode == 'move') {
                const timescale = self.timescale;
                if (timescale == 'day') {
                  const minute = parseInt(startTime.minutes() / 15) * 15;
                  if (minute >= 60) {
                    startTime.add(1, 'hour');
                    startTime.minutes(0);
                  } else {
                    startTime.minutes(minute);
                  }
                } else {
                  //Reuse the original time (hour and minute). 
                  startTime = moment.utc(`${startTime.format('YYYY-MM-DD')} ${oldStartDateTime.format('HH:mm')}`, 'YYYY-MM-DD HH:mm');
                  closeTime = moment.utc(`${closeTime.format('YYYY-MM-DD')} ${oldCloseDateTime.format('HH:mm')}`, 'YYYY-MM-DD HH:mm');

                  let calendar = null;
                  if (self.locationCalendarMap != null && self.locationCalendarMap instanceof Map) {
                    const locationCalendarMap = self.locationCalendarMap;
                    if (locationCalendarMap.has(data.projLocationId)) {
                      calendar = locationCalendarMap.get(data.projLocationId);
                    }
                  }
                  if (calendar == null) {
                    calendar = self.calendar;
                  }

                  let trigger = TRIGGERS.START_DATE;
                  let projectScheduleFromStart = true;

                  if (self.project != null && self.project.scheduleFrom == 'ALAP') { //Used by AgGridGantt
                    trigger = TRIGGERS.CLOSE_DATE;
                    projectScheduleFromStart = false;
                  }

                  let taskAutoScheduleMode = data.auto_scheduling;

                  if (timescale != 'day') { //expect 'week', 'month', and 'year'
                    startTime.hour(oldStartDateTime.hours()).minute(oldStartDateTime.minutes());
                    closeTime.hour(oldCloseDateTime.hours()).minute(oldCloseDateTime.minutes());
                  }

                  const payload = {
                    trigger: trigger
                    , startDateStr: projectScheduleFromStart? startTime.format('YYYY-MM-DD'): null
                    , startTimeStr: projectScheduleFromStart? startTime.format('HH:mm') : null
                    , closeDateStr: !projectScheduleFromStart? closeTime.format('YYYY-MM-DD'): null
                    , closeTimeStr: !projectScheduleFromStart? closeTime.format('HH:mm'): null
                    , durationDisplay: data.tm_duration_display //tm_duration_display is set in beforeTaskDrag event for task move mode  (helper-gantt-template.js)
                    , calendar: calendar
                    , projScheduleFromStart: projectScheduleFromStart
                    , taskAutoScheduleMode: taskAutoScheduleMode
                    , lockDuration: false
                    , autoMoveForNonWorkingDay: true
                    , skipOutOfProjectDateCheck: true
                  }
                  if (self?.durationConversionOpts != null) {
                    payload.durationConversionOpts = self.durationConversionOpts;
                  }
                  
                  const result = calcDateTimeDurationv2(payload);
                  startTime = result.startDateStr != null? moment.utc(`${result.startDateStr}${result.startTimeStr != null? ' '+result.startTimeStr:''}`, 'YYYY-MM-DD HH:mm') : null
                  closeTime = result.closeDateStr != null? moment.utc(`${result.closeDateStr}${result.closeTimeStr != null? ' '+result.closeTimeStr:''}`, 'YYYY-MM-DD HH:mm') : null
                }
              } else if (data.dragMode == 'resize') {
                dragMode = `resize_${data.resizeRight? 'right' : 'left'}`;
                if (self.timescale != 'day') {
                  if (data.resizeRight) {
                    const oct = oldCloseDateTime;
                    closeTime.hour(oct.hour()).minute(oct.minute());
                  } else {
                    const ost = oldStartDateTime;
                    startTime.hour(ost.hour()).minute(ost.minute());
                  }
                }
              } else if (data.dragMode == 'progress') {
                dragMode = 'progress';
              }

              if(self) {
                self.$emit('taskUpdated', {
                  dragMode: dragMode
                  , taskUuId: id
                  , taskName: data.temp_text != null? data.temp_text : data.text
                  , progressComplete: data.originalProgress == 1
                  , startDateStr: startTime.format('YYYY-MM-DD')
                  , startTimeStr: startTime.format('HH:mm')
                  , closeDateStr: closeTime.format('YYYY-MM-DD')
                  , closeTimeStr: closeTime.format('HH:mm')
                  , durationDisplay: durationDisplay
                  , lockDuration: data.lockDuration != null? data.lockDuration : false
                  , taskAutoScheduleMode: data.auto_scheduling != null? data.auto_scheduling : true
                  , constraintType: data.constraintType
                  , constraintDateStr: constraintDate != null? constraintDate.format('YYYY-MM-DD'): null
                  , oldStartDateStr: oldStartDateTime != null? oldStartDateTime.format('YYYY-MM-DD') : null
                  , oldStartTimeStr: oldStartDateTime != null? oldStartDateTime.format('HH:mm') : null
                  , oldCloseDateStr: oldCloseDateTime != null? oldCloseDateTime.format('YYYY-MM-DD') : null
                  , oldCloseTimeStr: oldCloseDateTime != null? oldCloseDateTime.format('HH:mm') : null
                  , progress: (parseInt(data.progress * 100) / 100).toFixed(2)
                });
              }
              
              return Promise.resolve({ 'action': 'updated' });
            }, 50)
            , create: function(/** data */) {
              // This create() should not be called theoretically as its 'create' event is interceptted by task modal.
              return Promise.resolve({ 'action': 'error' });
            }
            , delete: function(/** id */) {
              // This delete() should not be called theoretically as no UI to trigger it. Task modal has its own delete logic.
              return Promise.resolve({ 'action': 'error' });
            }
          }
          , link: {
            update: function(/** data, id */) {
              // This update() should not be called theoretically as no UI to trigger it. Task Link modal has its own update logic.
              return Promise.resolve({ 'action': 'error' });
            }
            , create: function(data) {
              const successor = [{
                uuId: data.target
                , type: data.type
                //, lag: data.lag //May not be supplied in data object
              }]
              return linkService.create(data.source, successor)
              .then(resp => {
                const rData = resp.data[resp.data.jobCase][0];
                if(self) {
                  self.$emit('taskLinkCreated', rData.uuId);
                }
                return { 
                  'action': 'inserted'
                  , 'tid': rData.uuId
                }
              })
              .catch(() => {
                if(self) {
                  self.$emit('taskLinkCreateError');
                }
                return { 'action': 'error' }
              });
            }
            , delete: function(/** id */) {
              // This delete() should not be called theoretically as no UI to trigger it. Task Link modal has its own delete logic.
              return Promise.resolve({ 'action': 'error' });
            }
          }
        }
      }
    },
    viewMouseEnterEvent() {
      return this.isTouchDevice()? null : 'mouseenter';
    },
    companyrule() {
      if (this.$store.state.company && this.$store.state.company.type !== 'Primary' &&
          this.$store.state.company.filterIds) {
        const companies = this.$store.state.company.filterIds;
        const companyrule = ['PROJECT.COMPANY.uuId', 'within', companies.join('|')];
        return companyrule
      }
      return null;
    },
    colorMouseEnterEvent() {
      return this.isTouchDevice()? null : 'mouseenter';
    },
    displaySettingsMouseEnterEvent() {
      return this.isTouchDevice()? null : 'mouseenter';
    }
  },
  watch: {
    companyrule() {
      if (typeof this.$store.state.company.filterIds !== 'undefined') {
        this.listProjects();
      }
    },
    'control.startDate': function() {
      this.handleDateRange();
    }, 
    'control.endDate': function() {
      this.handleDateRange();
    },
    'control.timescale': function() {
      if (this.profiles.projectTimescale !== this.control.timescale) {
        this.profiles.projectTimescale = this.control.timescale;
        this.updateProjectProfile();
      }
    },
    taskSelection: function(newValue) {
      this.hasAutoAssignTasks = this.autoAssignTasks().length > 0;
      this.taskSelectionIds.splice(0, this.taskSelectionIds.length, ...newValue.map(i => i.uuId));
    }
  },
  beforeMount() {
    this.userId = this.$store.state.authentication.user.uuId;
    const self = this;
    const profileKey = 'project_tile_list';
    
    
    this.gridOptions = {
      onSelectionChanged: function(event) {
        self.taskSelectionIds.splice(0, self.taskSelectionIds.length, ...(event.api.getSelectedNodes().map(i => i.data.uuId)));
      },
      onRowClicked: function(event) {
        if (event.data.scheduleStart &&
            event.data.scheduleFinish) {
          if (moment(self.control.startDate).unix() * 1000 > event.data.scheduleStart) {
            self.control.startDate = moment(event.data.scheduleStart).format('YYYY-MM-DD');
          }
          
          if (moment(self.control.endDate).unix() * 1000 < event.data.scheduleFinish) {
            self.control.endDate = moment(event.data.scheduleFinish).format('YYYY-MM-DD');
          }
          
          setTimeout(() => {
            var task = self.gantt.getTask(event.data.uuId);
            var sizes = self.gantt.getTaskPosition(task, task.start_date, task.end_date);
            const sPos = self.gantt.getScrollState();
            self.gantt.scrollTo(sizes.left - 40, sPos.y);
          }, 500);
        }
      },
      
      onBodyScroll: function(event) {
        self.scrollState.triggeredByLHSGrid = false;
        self.scrollState.triggeredByRHSChart = false;
        if(self.scrollState.top != event.top) {
          self.scrollState.triggeredByLHSGrid = true;
          self.scrollState.top = event.top;
        }
      },
      onColumnVisible: function(params) {
        let fromToolPanel = params.source == "toolPanelUi"
        if (fromToolPanel) {
          let colKey = params.column.colId;
          let columnMenuColumnIndex = params.api
            .getAllGridColumns()
            .findIndex(col => {
              return col === self.lastOpenColumnMenuParams.column;
            });

          params.api.moveColumns([colKey], columnMenuColumnIndex + 1);
        }
        const cols = params.api.getAllGridColumns().map(i => { 
          return { colId: i.colId, headerName: i.colDef.headerName, hide: i.colDef.hide, pinned: i.pinned }} )
        const columnState =  params.api.getColumnState();
        //get the actual hide value from columnState
        for (const col of columnState) {
          const found = cols.find(i => i.colId == col.colId)
          if (found) {
            found.hide = col.hide;
          }
        }
        cols.sort(columnDefSortFunc)
        for (const [index,c] of cols.entries()) {
          params.api.moveColumns([c.colId], index);
        }

        const columns = params.api.getAllDisplayedColumns();
        self.profiles[profileKey] = columns.map(c => getColumnDefs(c));
          
        // Save the new layout after applying it
        self.updateProjectProfile();
      },
      postProcessPopup: params => {
        if ((params.type == 'columnMenu')) {
          self.lastOpenColumnMenuParams = params;
        }
      },
      onSortChanged: function(event) {
        const columns = event.api.getAllDisplayedColumns();
        self.profiles[profileKey] = columns.map(c => getColumnDefs(c));
        self.updateProjectProfile();
      },
      onDragStopped: function(event) {
        const columns = event.api.getAllDisplayedColumns();
        self.profiles[profileKey] = columns.map(c => getColumnDefs(c));
        self.updateProjectProfile();
      },
      onFirstDataRendered: function(event) {
        if (self.newToProfile != null && self.newToProfile == true) {
          self.newToProfile = null;
          self.gridApi.sizeColumnsToFit();
          self.$nextTick(() => {
            const columns = event.api.getAllDisplayedColumns();
            self.profiles[profileKey] = columns.map(c => getColumnDefs(c));
            self.updateProjectProfile();
          })
        }
      }
    };
    const colDefs = [
      {
        headerName: this.$t('project.title'),
        field: 'uuId',
        cellRenderer: 'detailLinkCellRenderer',
        checkboxSelection: false,
        lockVisible: true,
        pinned: 'left',
        minWidth: 150,
        hide: false,
        sort: 'asc',
        cellStyle: params => {
            if (params.data &&
                params.data.color &&
                self.coloring.project) {
                return { background: params.node.data.color, color: invertColor(params.node.data.color, true) };
            }
            else if (params.data &&
                params.data.companyColor &&
                self.coloring.company) {
                      const color = getFirstColor(params.node.data.companyColor);
                      if (color) return { background: color, color: invertColor(color, true) };
            }
            else if (params.data &&
                params.data.locationColor &&
                self.coloring.location) {
                      const color = getFirstColor(params.node.data.locationColor);
                      if (color) return { background: color, color: invertColor(color, true) };
            }
            else if (params.data &&
                params.data.customerColor &&
                self.coloring.customer) {
                      const color = getFirstColor(params.node.data.customerColor);
                      if (color) return { background: color, color: invertColor(color, true) };
            }
            else if (params.data &&
                params.data.statusColor &&
                self.coloring.status) {
                      const color = getFirstColor(params.node.data.statusColor);
                      if (color) return { background: color, color: invertColor(color, true) };
            }
            else if (params.data &&
                params.data.rebateColor &&
                self.coloring.rebate) {
                      const color = getFirstColor(params.node.data.rebateColor);
                      if (color) return { background: color, color: invertColor(color, true) };
            }
        }
      },
      {
        headerName: this.$t('project.field.customer'),
        field: 'customers',
        cellRenderer: 'genericEntityArrayCellRenderer',
        hide: false
      },
      {
        headerName: this.$t('project.field.progress'),
        field: 'progress',
        cellRenderer: 'percentageCellRenderer',
        hide: false
      },
      {
        headerName: this.$t('project.field.scheduleStart'),
        field: 'scheduleStart',
        cellRenderer: 'dateTimeCellRenderer',
        hide: false
      },
      {
        headerName: this.$t('project.field.scheduleFinish'),
        field: 'scheduleFinish',
        cellRenderer: 'dateTimeCellRenderer',
        hide: false
      },
      {
        headerName: this.$t('project.field.estimatedDuration'),
        field: 'estimatedDuration',
        cellRenderer: 'durationCellRenderer',
        cellRendererParams: {
          unit: 'days'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.fixedDuration'),
        field: 'fixedDuration',
        cellRenderer: 'durationCellRenderer',
        cellRendererParams: {
          unit: 'days'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.company'),
        field: 'companies',
        cellRenderer: 'genericEntityArrayCellRenderer'
      },
      {
        headerName: this.$t('project.field.location'),
        field: 'locations', 
        cellRenderer: 'genericEntityArrayCellRenderer'
      },
      {
        headerName: this.$t('project.field.priority'),
        field: 'priority',
        hide: true
      },
      {
        headerName: this.$t('project.field.scheduleMode'),
        field: 'scheduleMode',
        hide: true
      },
      {
        headerName: this.$t('project.field.description'),
        field: 'description',
        hide: true
      },
      {
        headerName: this.$t('project.field.currencyCode'),
        field: 'currencyCode',
        hide: true
      },
      {
        headerName: this.$t('project.field.fixedCost'),
        field: 'fixedCost',
        cellRenderer: 'costCellRenderer',
        cellRendererParams: {
          customCurrencyProp: 'currencyCode'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.fixedCostNet'),
        field: 'fixedCostNet',
        cellRenderer: 'costCellRenderer',
        cellRendererParams: {
          customCurrencyProp: 'currencyCode'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.actualCost'),
        field: 'actualCost',
        cellRenderer: 'costCellRenderer',
        cellRendererParams: {
          customCurrencyProp: 'currencyCode'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.actualCostNet'),
        field: 'actualCostNet',
        cellRenderer: 'costCellRenderer',
        cellRendererParams: {
          customCurrencyProp: 'currencyCode'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.estimatedCost'),
        field: 'estimatedCost',
        cellRenderer: 'costCellRenderer',
        cellRendererParams: {
          customCurrencyProp: 'currencyCode'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.estimatedCostNet'),
        field: 'estimatedCostNet',
        cellRenderer: 'costCellRenderer',
        cellRendererParams: {
          customCurrencyProp: 'currencyCode'
        },
        hide: true
      },
      {
        headerName: this.$t('project.field.rebates'),
        field: 'rebates',
        cellRenderer: 'rebateCellRenderer'
      },
      {
        headerName: this.$t('project.field.status'),
        field: 'status',
        cellRenderer: 'genericObjectCellRenderer',
        hide: false
      },
      {
        headerName: this.$t('project.field.stages'),
        field: 'stageNames',
        hide: true
      },
      {
        headerName: this.$t('project.field.tag'),
        field: 'tag',
        hide: true
      },
      {
        headerName: this.$t('field.color'),
        field: 'color',
        cellRenderer: 'colorCellRenderer',
        hide: true
      },
      {
        headerName: this.$t('field.identifier_full'),
        field: 'identifier'
      }
    ];
    
    const linkedEntities = [
      { selector: 'PROJECT.CUSTOMER', field: 'customer', properties: ['name'] },
      { selector: 'PROJECT.COMPANY', field: 'company', properties: ['name'] },
      { selector: 'PROJECT.LOCATION', field: 'location', properties: ['name'] },
      { selector: 'PROJECT.STAGE', field: 'status', properties: ['name'] },
      { selector: 'PROJECT.REBATE', field: 'rebate', properties: ['name'] },
      { selector: 'PROJECT.TAG', field: 'tag', properties: ['name'] },
      { selector: 'PROJECT', field: 'fixedCost', properties: ['currencyCode'] },
      { selector: 'PROJECT', field: 'fixedCostNet', properties: ['currencyCode'] },
      { selector: 'PROJECT', field: 'actualCost', properties: ['currencyCode'] },
      { selector: 'PROJECT', field: 'actualCostNet', properties: ['currencyCode'] },
      { selector: 'PROJECT', field: 'estimatedCost', properties: ['currencyCode'] },
      { selector: 'PROJECT', field: 'estimatedCostNet', properties: ['currencyCode'] }
    ]
    
    
    getCustomFieldInfo(this, 'PROJECT').then(() => {
      prepareCustomFieldColumnDef(colDefs, self.customFields, { self });
      
      for (const col of colDefs) {
        col.editable = false; // turn off editing for custom fields
      }
      
      this.columnDefs = colDefs;
      this.$store.dispatch('data/schemaAPI', {type: 'api', opts: 'brief' })
      .finally(() => {
        filterOutViewDenyProperties(colDefs, 'PROJECT', linkedEntities);
        colDefs.sort(columnDefSortFunc);
        this.columnDefs = colDefs;
      });
  
      this.defaultColDef = {
        sortable: true,
        resizable: true,
        minWidth: 100,
        lockPinned: true,
        hide: true,
        cellClass: 'projecttile-lhs-default-cell',
        menuTabs: ['columnsMenuTab']
      };
      this.context = {
        componentParent: self
      };
      this.loadColumnSettings(this, this.profiles.project_tile_list);
    });
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      
      if (this.profiles['projectGanttLHSGrid'] && this.$refs['lhs-grid']) {
        this.$refs['lhs-grid'].style.width = this.profiles['projectGanttLHSGrid'].width;
      }
      if (this.profiles['projectGanttRHSChart'] && this.$refs['rhs-chart']) {
        this.$refs['rhs-chart'].style.width = this.profiles['projectGanttRHSChart'].width;
      }
  
      const self = this;
      const updateData = () => {
        params.api.setGridOption('serverSideDatasource', new ServerSideDatasource(self));
      };

      updateData();
      
    },
    progressFilter(progress) {
      let result = false;
      
      if (typeof progress === 'undefined') {
        return true; // progress has been denied
      }
      
      // Progress filters
      let byProgress = [];
      Object.keys(this.progressFilters).forEach(f => {
        if (this.progressFilters[f]) {
          byProgress.push(f)
        }
      })

      byProgress.forEach(p => {
        if (p == "_progress0" &&
            progress === 0) {
          result = true;
        }
        // Reminder: range is >= and <
        if (p == "_progress25" &&
            progress >= 0.01 && progress < 0.26) {
          result = true;
        }
        if (p == "_progress50" &&
            progress >= 0.26 && progress < 0.51) {
          result = true;
        }
        if (p == "_progress75" &&
            progress >= 0.51 && progress < 0.76) {
          result = true;
        }
        if (p == "_progress99" &&
            progress >= 0.76 && progress < 1.0) {
          result = true;
        }
        if (p == "_progress100" &&
            progress === 1) {
          result = true;
        }
      });
      return result;
    },
    shouldDisplay(project) {
      const status = project.status && Array.isArray(project.status) ? project.status.join() : project.status;
      
      return this.progressFilter(project.progress) &&
             ((project.name != null && project.name.toLowerCase().includes(this.searchFilter.toLowerCase())) ||
             (project.description != null && project.description.toLowerCase().includes(this.searchFilter.toLowerCase())) ||
             (project.customerName != null && project.customerName.join().toLowerCase().includes(this.searchFilter.toLowerCase())) ||
             (status != null && status.toLowerCase().includes(this.searchFilter.toLowerCase())) ||
             (project.tag && project.tag.filter(t => t.toLowerCase().includes(this.searchFilter.toLowerCase())).length !== 0));
    },
    filteredFavProjects() {
      const favProjects = this.favProjects;
      const projects = [];
      for (var project of favProjects) {
        if (this.shouldDisplay(project)) {
          projects.push(project);
        }
      }
      return projects;
    },
    sortIdxFunc(a, b) {
      const order = "asc";
      if (this.projectOrder[a.uuId] < this.projectOrder[b.uuId]) {
        return order === "asc" ? -1 : 1;
      }
      else if (this.projectOrder[a.uuId] > this.projectOrder[b.uuId]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    },
    onExpand() {
      this.profiles.showProjects = this.allProjectsExpanded;
      this.updateProjectProfile();
    },
    toggleVisible(key) {
      this.display[key] = !this.display[key];
      this.profiles.display = this.display;
      this.updateProjectProfile();
    },
    toggleProgressFilter(key) {
      this.progressFilters[key] = !this.progressFilters[key];
      this.profiles.progressFilters = this.progressFilters;
      this.updateProjectProfile();
      
      if (!this.tileView) {
        this.gridApi.refreshServerSide({ purge: true });
      }
    },
    showProjectSettings() {
      this.filterShow = true;
    },
    clearProjectSettings() {
      this.filter = null;
      this.profiles.filter = null;
      
      this.updateProjectProfile();
      
      if (this.tileView) {
        this.listProjects();
      }
      else {
        this.gridApi.refreshServerSide({ purge: true });
      }
    },
    async getProjectList(ksort, ksortType, filter) {
      this.loading = true;
      await projectService.tilesList({ start: 0, limit: -1, ksort: ksort, ksortType: ksortType, order: this.filter !== null ? this.filter.sortdirection : null, filter: filter, badgeFilters: this.badgeFilters }, true, true)
      .then(response => {
        const projects = response.data;
        const tmpProjects = [];
        let idx = 0;
        let counter = 0;
        const chunk = 50;
        let tmpBatch = [];
        this.projectBatch.length = 0;
        let batchNo = 0;
        for (const project of projects) {
          this.projectOrder[project.uuId] = idx++;
          if (counter >= chunk) {
            this.projectBatch.push(tmpBatch);
            batchNo = this.projectBatch.length;
            tmpBatch = [];
            counter = 0;
          }
          if (!(project.uuId in this.profiles) || !this.profiles[project.uuId].favourite) {
            project.favourite = false;
          } else {
            project.favourite = true;
          }
          project.forceRender = false;
          project.batchNo = batchNo;
          tmpProjects.push(project);
          tmpBatch.push(project);
          counter++;
        }
        if (tmpBatch.length > 0) {
          this.projectBatch.push(tmpBatch);
        }

        this.projects = tmpProjects;
        this.loading = false;
      })
      .catch((error) => {
        console.error(error); // eslint-disable-line no-console
        this.projects = [];
        this.loading = false;
      });
    },
    async listProjects() {
      let filter = this.filter !== null ? buildFilter(this.filter.entity, this.filter.query) : null;

      var ksort = this.filter !== null ? this.filter.sortfield : null;
      var ksortType = null;
      if (ksort !== null && ksort.includes('.=')) {
        ksort = transformField(ksort, 'Macro', 'sort');
      }
      else if (ksort !== null) {
        ksortType = getFieldType(ksort, this.schema);
      }
      
      this.projects = [];
      this.favProjects = [];
      this.projectOrder = {};
      const companyrule = this.companyrule;
      if (companyrule) {
        if (filter === null) {
          filter = [companyrule];
        }
        else {
          filter.push(companyrule);
        }
      }

      await this.getProjectList(ksort, ksortType, filter);

      // get the favourites
      const uuIds = [];
      for (var key of Object.keys(this.profiles)) {
        if (this.profiles[key] && this.profiles[key].favourite) {
          uuIds.push(key);
        }
      }
      
      if (uuIds.length !== 0) {
        this.loadingFav = true;
        await projectService.tilesList({ limit: -1, ksort: ksort, ksortType: ksortType, filter: filter, badgeFilters: this.badgeFilters, order: this.filter !== null ? this.filter.sortdirection : null, uuIds: uuIds }, true, true)
        .then(response => {
          const projects = response.data;
          
          this.favProjects = projects;
          this.loadingFav = false;
        })
        .catch(function(error) {
          this.loadingFav = false;
          console.error(error); // eslint-disable-line no-console
        });
      }
    },
    toggleFavourite(result) {
      const uuId = result.uuId;
      const favourite = result.favourite;
      if (!(uuId in this.profiles)) {
        this.profiles[uuId] = { favourite: favourite };
      }
      else {
        this.profiles[uuId].favourite = favourite;
      }
      
      if (favourite) {
        const index = this.projects.findIndex((project) => {
          return project.uuId === uuId;
        });
        const project = this.projects[index];
        project.favourite = true;
        this.favProjects.push(project);
        this.favProjects.sort(sortFunc);
      }
      else {
        const favIndex = this.favProjects.findIndex((project) => {
          return project.uuId === uuId;
        });
        const favProject = (this.favProjects.splice(favIndex, 1))[0];
        const project = this.projects.find(p => { 
          return p.uuId == favProject.uuId;
        }) ;
        if (project != null) {
          project.favourite = false;
          project.forceRender = true; //Force rendering the tile content. The tile may have no content and it is in the viewport. Reason: The scroll event is not triggered.
        }
      }
      this.updateProjectProfile();
    },
    getColorBy(data) {
      if (data &&
        data.color &&
        this.coloring.project) {
        return data.color;
      }
      else if (data &&
        data.companyColor &&
        this.coloring.company) {
        const color = getFirstColor(data.companyColor);
        if (color) return color;
      }
      else if (data &&
        data.locationColor &&
        this.coloring.location) {
        const color = getFirstColor(data.locationColor);
        if (color) return color;
      }
      else if (data &&
        data.customerColor &&
        this.coloring.customer) {
        const color = getFirstColor(data.customerColor);
        if (color) return color;
      }
      else if (data &&
        data.statusColor &&
        this.coloring.status) {
        const color = getFirstColor(data.statusColor);
        if (color) return color;
      }
      else if (data &&
        data.rebateColor &&
        this.coloring.rebate) {
        const color = getFirstColor(data.rebateColor);
        if (color) return color;
      }
      return null;
    },
    projectClass(totalProgress) {
      const progress = Math.trunc(totalProgress * 100);
      var progressClass = 'project-tile ';
      
      if (typeof totalProgress === 'undefined') {
        progressClass += 'project-tile-none';
      }
      else if (progress == 0) {
        progressClass += 'project-tile-0';
      }
      else if (progress <= 25) {
        progressClass += 'project-tile-25';
      }
      else if (progress <= 50) {
        progressClass += 'project-tile-50';
      }
      else if (progress <= 75) {
        progressClass += 'project-tile-75';
      }
      else if (progress <= 99) {
        progressClass += 'project-tile-99';
      }
      else if (progress === 100) {
        progressClass += 'project-tile-100';
      }
      return progressClass;
    },
    projectStyle(project) {
      const color = this.getColorBy(project);
      if (color) {
        return { background: color, color: invertColor(color, true) };
      }
      return '';
    },
    ok(payload) {
      console.log(payload); // eslint-disable-line no-console
    },
    async createProjectProfile() {
      const data = await projectProfileService.create([this.profiles],
                        this.userId).then((response) => {  
        const data = response.data[response.data.jobCase];
        return data[0];
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
        return null;
      });
      return data;
    },
    async listProjectProfiles() {
      const self = this;    
      let params = new URL(document.location.toString()).searchParams;
      
      const profileData = await projectProfileService.list(this.userId).then((response) => {  
        return response.data[response.data.jobCase];
      })
      .catch((e) => {
        console.log(e); // eslint-disable-line no-console
        return null;
      });
      
      if (profileData.length === 0) {
        this.useDefault = true;
        const result = await this.createProjectProfile();
        this.profiles = { 
          kind: "project",
          uuId: result.uuId,
          showProjects: true
        };
        const defaultView = this.projectViews.find(v => v.defaultView);
        if (defaultView) {
          this.loadViewSettings(defaultView);
        }
      }
      else {
        this.profiles = profileData[0];
        if (!params.has("view")) {
          this.tileView = typeof profileData[0].tileView !== 'undefined' ? profileData[0].tileView : true;
          this.loadColumnSettings(this, this.profiles.project_tile_list);
          this.filter = typeof profileData[0].filter !== 'undefined' ? profileData[0].filter : null;
          for (const key of Object.keys(this.display)) {
            this.display[key] = typeof profileData[0].display !== 'undefined' && typeof profileData[0].display[key] !== 'undefined' ? profileData[0].display[key] : true;
          }
          this.progressFilters = typeof profileData[0].progressFilters !== 'undefined' ? profileData[0].progressFilters : {
            _progress0: true,
            _progress25: true,
            _progress50: true,
            _progress75: true,
            _progress99: true,
            _progress100: true
          };
          this.allProjectsExpanded = this.profiles.showProjects != null? this.profiles.showProjects : true;
          
          this.coloring.none = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.none : true;
          this.coloring.project = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.project : false;
          this.coloring.company = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.company : false;
          this.coloring.location = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.location : false;
          this.coloring.customer = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.customer : false;
          this.coloring.status = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.status : false;
          this.coloring.rebate = this.profiles.project_tiles_coloring ? this.profiles.project_tiles_coloring.rebate : false;
        }
      }
      
      if (!params.has("view")) {
        if(Object.prototype.hasOwnProperty.call(this.profiles, 'projectGanttControlDates')) {
          self.$set(self.control, 'dates', this.profiles['projectGanttControlDates']);
        }
        if(Object.prototype.hasOwnProperty.call(this.profiles, 'projectTimescale')) {
          self.$set(self.control, 'timescale', this.profiles['projectTimescale']);
        }
        if(Object.prototype.hasOwnProperty.call(this.profiles, 'projectGanttControlStartDate')) {
          self.$set(self.control, 'startDate', this.profiles['projectGanttControlStartDate']); 
        }
        if(Object.prototype.hasOwnProperty.call(this.profiles, 'projectGanttControlEndDate')) {
          self.$set(self.control, 'endDate', this.profiles['projectGanttControlEndDate']); 
        }
        if(Object.prototype.hasOwnProperty.call(this.profiles, 'projectGanttControlStartDate') || Object.prototype.hasOwnProperty.call(this.profiles, 'projectGanttControlEndDate')) {
          self.datesChangeFlag = true;
          self.handleDateRange();
        }
  
        if (this.profiles['projectGanttLHSGrid'] && self.$refs['lhs-grid']) {
          self.$refs['lhs-grid'].style.width = this.profiles['projectGanttLHSGrid'].width;
        }
        if (this.profiles['projectGanttRHSChart'] && self.$refs['rhs-chart']) {
          self.$refs['rhs-chart'].style.width = this.profiles['projectGanttRHSChart'].width;
        }

        self.filterText = typeof self.profiles.projectSearchValue !== 'undefined' ? self.profiles.projectSearchValue : '';
        if (self.filterText !== '') {
          self.changeFilter(self.filterText, false);
        }
        self.filterPinned = self.profiles.filterPinned == true;
        self.badgeFilters = typeof self.profiles.projectsBadgeFilter !== 'undefined' ? self.profiles.projectsBadgeFilter : [];
        self.badgeFilterPinned = self.profiles.projectsBadgeFilterPinned == true;
        
        if (self.profiles.projects_viewName) {
          this.$store.dispatch("breadcrumb/updateView", self.profiles.projects_viewName, { root: true });
        }
      }  
      await this.listProjects();
    },
    async updateProjectProfile({ clearViewName=true } = {}) {
      
      // clear the view name from the breadcrumb
      if (clearViewName) {
        this.profiles.projects_viewName = null;
        this.$store.dispatch("breadcrumb/clearView");
      }
      
      if (this.profiles.uuId) {
        const data = await projectProfileService.update([this.profiles],
                          this.userId).then((response) => {  
          const data = response.data[response.data.jobCase];
          return data[0];
        })
        .catch((e) => {
          console.log(e); // eslint-disable-line no-console
          return null;
        });
        return data;
      }
    },
    onViewOver() {
      this.$refs.view.visible = true;
    },
    onViewLeave(arg) {
      if (arg.toElement &&
          typeof arg.toElement.className === 'string' &&
          arg.toElement.className !== 'arrow' &&
          arg.toElement.className && !arg.toElement.className.startsWith('popover')) {
        this.$refs.view.visible = false;
      }
    },
    async loadViewSettings(view) {
      const uuId = this.profiles.uuId;
      this.profiles = cloneDeep(view.profiles);
      this.profiles.uuId = uuId;
      this.filter = this.profiles.filter ? this.profiles.filter : null;
      for (const key of Object.keys(this.display)) {
        this.display[key] = typeof this.profiles.display[key] !== 'undefined' ? this.profiles.display[key] : true;
      }
      
      this.tileView = typeof view.tileView !== 'undefined' ? view.tileView : true;
      this.loadColumnSettings(this, view.project_tile_list);
      this.progressFilters = this.profiles.progressFilters;
      this.allProjectsExpanded = this.profiles.showProjects;
      this.coloring.none = view.coloring ? view.coloring.none : true;
      this.coloring.project = view.coloring ? view.coloring.project : false;
      this.coloring.company = view.coloring ? view.coloring.company : false;
      this.coloring.location = view.coloring ? view.coloring.location : false;
      this.coloring.customer = view.coloring ? view.coloring.customer : false;
      this.coloring.status = view.coloring ? view.coloring.status : false;
      this.coloring.rebate = view.coloring ? view.coloring.rebate : false;
      if (view.controlDates == null) {
        if (view.startDate) {
          this.control.startDate = cloneDeep(view.startDate);
        }
        if (view.endDate) {
          this.control.endDate = cloneDeep(view.endDate);
        }
      }
      if (this.tileView != true) {
        this.handleControlDates(view.controlDates);
      }
      
      if (view.span) {
        this.control.timescale = cloneDeep(view.span);
      }
      
      this.badgeFilters = Array.isArray(view.badgeFilters) ?  view.badgeFilters : [];
      this.profiles.projectsBadgeFilter = this.badgeFilters;
      
      await this.listProjects();
      
      this.profiles.projectSearchValue = this.filterText = view.searchValue;
      this.changeFilter(view.searchValue, false);
      
      // save the view name in the profile
      this.profiles.projects_viewName = view.name;
           
      // Save the new layout after applying it
      this.updateProjectProfile({ clearViewName: false });
      
      this.$store.dispatch("breadcrumb/updateView", view.name, { root: true });
    },
    savePreset() {
      this.saveName = null;
      this.saveIndex = -1;
      const columns = this.gridApi ? this.gridApi.getAllDisplayedColumns() : null;
      this.profiles.display = this.display;
      this.profiles.progressFilters = this.progressFilters;
      this.profiles.showProjects = this.allProjectsExpanded;
      this.profiles.tileView = this.tileView;
      
      this.saveProfile = { 
        type: 'project',
        sharingMembers: cloneDeep(this.userId),
        editingPermissions: cloneDeep(this.userId), 
        profiles: this.profiles,
        searchValue: this.filterText,
        coloring: this.coloring,
        tileView: this.tileView,
        project_tile_list: columns ? columns.map(c => getColumnDefs(c)) : null,
        startDate: this.control.startDate,
        endDate: this.control.endDate,
        span: this.control.timescale,
        controlDates: this.profiles.projectGanttControlDates,
        lHSGrid: this.profiles.projectGanttLHSGrid,
        rHSChart: this.profiles.projectGanttRHSChart,
        filter: this.profiles.filter,
        badgeFilters: JSON.parse(JSON.stringify(this.badgeFilters))
      };
      this.promptSaveShow = true;
    },
    async updateUsers(profile, updateUsers, service) {
      if (updateUsers) {
        const users = updateUsers.split(',');
        for (const user of users) {
          const profileData = await service.list(user)
           .then(response => {
             return response.data[response.data.jobCase];
          });
         
          if (profileData.length > 0) {
            profileData[0].tileView = profile.tileView;
            profileData[0].project_tile_list = profile.project_tile_list;
            profileData[0].filter = profile.filter;
            profileData[0].display = profile.profiles.display;
            profileData[0].progressFilters = profile.profiles.progressFilters;
            profileData[0].showProjects = profile.profiles.showProjects;
            profileData[0].project_tiles_coloring = profile.coloring;
            profileData[0].projectGanttControlDates = profile.controlDates
            profileData[0].projectTimescale = profile.span;
            profileData[0].projectGanttControlStartDate = profile.startDate;
            profileData[0].projectGanttControlEndDate = profile.endDate;
            profileData[0].projectGanttLHSGrid = profile.lHSGrid;
            profileData[0].projectGanttRHSChart = profile.rHSChart;
        
            profileData[0].projectSearchValue = profile.searchValue;
            profileData[0].projects_viewName = profile.name;
            
            await service.update(profileData, user)
          }
        }
      }
    },
    confirmSaveOk({ profile, newDefault, updateUsers, sharing }) {      
      if (newDefault) {
        // find the existing default view and turn it off
        const defaultView = this.projectViews.find(v => v.defaultView);
        if (defaultView) {
          defaultView.defaultView = false;
          viewProfileService.updatePreset([defaultView], this.userId)
          .catch((e) => {
            console.error(e); // eslint-disable-line no-console
          });
        }
      }
      
      this.updateUsers(profile, updateUsers, projectProfileService);
      
      if (this.saveIndex !== -1) {
        this.projectViews.splice(this.saveIndex, 1, profile);
      }
      else {
        this.addViews([profile]);
      }
      
      if (!sharing) {
        // save the view name in the profile
        this.profiles.projects_viewName = profile.name;
        this.$store.dispatch("breadcrumb/updateView", profile.name, { root: true });
        this.updateProjectProfile({ clearViewName: false });
      }
    },
    addViews(views) {
      for (const view of views) {
        // if not in the list, add it
        if (view.type === 'project' &&
            this.projectViews.findIndex((i) => i.uuId === view.uuId) === -1) {
          this.showInfo.push(false);
          this.projectViews.push(view);
          if (this.useDefault && view.defaultView) {
            this.loadViewSettings(view);
          }
          let params = new URL(document.location.toString()).searchParams;
          if (params.has("view")) {
            let uuId = params.get("view");
            if (view.uuId === uuId) {
              this.loadViewSettings(view);
            }
          }
        }
      }
      
      this.projectViews.sort(function( a, b ) {
        if ( a.name.toLowerCase() < b.name.toLowerCase() ){
          return -1;
        }
        if ( a.name.toLowerCase() > b.name.toLowerCase() ){
          return 1;
        }
        return 0;
      });
    },
    updateColumnSettings(index, name, profile) {
      this.saveName = name;
      const columns = this.gridApi ? this.gridApi.getAllDisplayedColumns() : null;

      this.profiles.showProjects = this.allProjectsExpanded;
      this.profiles.display = this.display;
      this.profiles.progressFilters = this.progressFilters;
      this.profiles.tileView = this.tileView;
      this.saveProfile = { 
        name: profile.name,
        uuId: profile.uuId,
        type: 'project',
        defaultView: profile.defaultView,
        sharedVisibility: cloneDeep(profile.sharedVisibility),
        sharingMembers: cloneDeep(profile.sharingMembers),
        profiles: this.profiles,
        searchValue: this.filterText,
        coloring: this.coloring,
        tileView: this.tileView,
        project_tile_list: columns ? columns.map(c => getColumnDefs(c)) : null,
        startDate: this.control.startDate,
        endDate: this.control.endDate,
        span: this.control.timescale,
        controlDates: this.profiles.projectGanttControlDates,
        lHSGrid: this.profiles.projectGanttLHSGrid,
        rHSChart: this.profiles.projectGanttRHSChart,
        filter: this.profiles.filter,
        badgeFilters: cloneDeep(this.badgeFilters)
      };
      this.saveIndex = index;
      this.promptSaveShow = true;
    },
    copyColumnSettings(index, name, profile) {
      this.saveName = `${name} ${this.$t('dataview.copy_text')}`;
      this.saveProfile = { 
        name: `${name} ${this.$t('dataview.copy_text')}`,
        uuId: null,
        type: 'project',
        sharedVisibility: 'private',
        sharingMembers: cloneDeep(this.userId),
        editingPermissions: cloneDeep(this.userId),
        profiles: profile.profiles,
        searchValue: profile.searchValue,
        coloring: profile.coloring,
        tileView: profile.tileView,
        project_tile_list: profile.project_tile_list,
        startDate: profile.startDate,
        endDate: profile.endDate,
        span: profile.span,
        controlDates: profile.projectGanttControlDates,
        lHSGrid: profile.projectGanttLHSGrid,
        rHSChart: profile.projectGanttRHSChart,
        filter: profile.filter,
        badgeFilters: cloneDeep(profile.badgeFilters),
        badgeFilterPinned: profile.badgeFilterPinned
      };
      this.saveIndex = -1;
      this.promptSaveShow = true;
    },
    shareColumnSettings(index, name, profile) {
      this.saveName = name;
      this.saveProfile = profile;
      this.saveIndex = index;
      this.promptShareShow = true;
    },
    removeColumnSettings(index) {
      this.confirmDeleteViewShow = true;
      this.deleteViewIndex = index;
    },
    confirmDeleteViewOk() {
      const toRemove = this.projectViews.splice(this.deleteViewIndex, 1);
      
      viewProfileService.remove([{ uuId: toRemove[0].uuId }],
                        this.userId).then(() => {  
                        //
      })
      .catch((e) => {
        console.error(e); // eslint-disable-line no-console
      });
    },
    isTouchDevice() {
      const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
      const mq = function (query) {
          return window.matchMedia(query).matches;
      }
      if ('ontouchstart' in window) {
          return true;
      }
      const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
      return mq(query);
    },
    editPermission(view) {
      if (typeof view.editingPermissions === 'undefined') {
        return true;    
      }
      
      return view.editingPermissions.includes(this.userId);
    },
    async loadUserProfile() {
      const self = this;
      await this.$store.dispatch('data/viewProfileList', self.userId).then((value) => {
        return value.length > 0 ? value[0] : {};
      })
      .catch((e) => {
        console.error(e); // eslint-disable-line no-console
      });
    
      const views = await this.$store.dispatch('data/presetviewProfileList', self.userId).then((value) => {
        return value;
      })
      .catch((e) => {
        console.error(e); // eslint-disable-line no-console
      });
      
      this.addViews(views);
    },
    async loadPublicProfile() {
      if (!localStorage.companyId) {
        const data = await companyService.list({limit: -1, start: 0}).then((response) => {
          return response.data;
        })
        .catch((e) => {
          console.error(e); // eslint-disable-line no-console
          return null;
        });

        if (data != null) {
          const company = data.filter(d => d.type === 'Primary');
          if (company.length > 0) {
            localStorage.companyId = company[0].uuId;
          }
        }
      }

      const views = await this.$store.dispatch('data/viewProfileListPublic', localStorage.companyId).then((value) => {
        return value;
      })
      .catch((e) => {
        console.error(e); // eslint-disable-line no-console
      });
      
      this.addViews(views);
    },
    onColoringOver() {
      this.$refs.coloring.visible = true;
    },
    onColoringLeave() {
      this.$refs.coloring.visible = false;
    },
    onColorChange(val) {
      for (const key of Object.keys(this.coloring)) {
        this.coloring[key] = false;
      }
      this.coloring[val] = true;
      this.profiles['project_tiles_coloring'] = this.coloring;
      this.updateProjectProfile();
      
      if (!this.tileView) {
        this.updateColoring();
        this.gridApi.redrawRows();
        if (this.gantt && !this.tileView) {
          this.$nextTick(() => {
            this.gantt.render();
          });
        }
      }
    },
    updateColoring() {
      this.gridApi.redrawRows();
      const ganttData = this.gantt.serialize();
       // set the colors
      for (var i = 0; i < ganttData.data.length; i++) {
        ganttData.data[i] = this.setGanttColors(ganttData.data[i]);
        
        // correct empty dates
        if (ganttData.data[i].scheduleStart === 0) {
          ganttData.data[i].start_date = moment(ganttData.data[i].scheduleStart).format('YYYY-MM-DD');
        }
        
        if (ganttData.data[i].scheduleFinish === 0) {
          ganttData.data[i].end_date = moment(ganttData.data[i].scheduleFinish).format('YYYY-MM-DD');
        }
      }
      const scrollY = this.gantt.getScrollState().y
      const scrollX = this.gantt.getScrollState().x
      this.gantt.parse(ganttData);
      this.signalApplyGanttMarker = true;
      this.gantt.scrollTo(scrollX, scrollY)
        
    }, 
    getRowColor(data) {
      if (data &&
        data.projectColor &&
        this.coloring.project) {
        return data.projectColor;
      }
      else if (data &&
        data.color &&
        this.coloring.project) {
        return data.color;
      }
      else if (data &&
        data.statusColor &&
        this.coloring.status) {
        return getFirstColor(data.statusColor);
      }
      else if (data &&
        data.rebateColor &&
        this.coloring.rebate) {
        return getFirstColor(data.rebateColor);
      }
      else if (data &&
        data.companyColor &&
        this.coloring.company) {
        return getFirstColor(data.companyColor);
      }
      else if (data &&
        data.customerColor &&
        this.coloring.customer) {
        return getFirstColor(data.customerColor);
      }
      else if (data &&
        data.locationColor &&
        this.coloring.location) {
        return getFirstColor(data.locationColor);
      }
    }, 
    setGanttColors(obj) {
      // clear the existing color
      delete obj['color'];
      delete obj['textColor'];
      delete obj['progressColor'];
      
      const color = this.getRowColor(obj);
      // set the color fields for use in gantt chart
      if (color) {
        obj.color = color;
        obj.textColor = invertColor(color, true);
        obj.progressColor = toComplimentary(color);
      }
      else {
        // white by default
        obj.color = '#fff';
        obj.textColor = '#000';
        obj.progressColor = '#7F7F7FAA';
      }
      return obj;
    },
    onDisplaySettingsOver() {
      this.$refs['project-tiles-display-settings'].visible = true;
    },
    onDisplaySettingsLeave() {
      this.$refs['project-tiles-display-settings'].visible = false;
    },
    toggleTileView() {
      this.tileView = !this.tileView;
      this.profiles.tileView = this.tileView;
      
      if (this.tileView) {
        this.listProjects();
      }
      if (this.gridApi != null && !this.gridApi.isDestroyed()) {
        //When switch from tile to list, griApi should be available, re-apply/reload the column definitions from profile again.
        //Without this step, an outdated column definition will be loaded.
        this.loadColumnSettings(this, this.profiles.project_tile_list);
      }
      // Save the new layout after applying it
      this.updateProjectProfile();
    },
    getFilter() {
      const filter = [];
  
      filter.push(['PROJECT.name', 'regex', `(?is).*${this.searchFilter}.*`]);
      if (this.canView('PROJECT', ['description'])) {
        filter.push(['PROJECT.description', 'regex', `(?is).*${this.searchFilter}.*`]);
      }
      if (this.canView('CUSTOMER')) {
        filter.push(['PROJECT.CUSTOMER.name', 'regex', `(?is).*${this.searchFilter}.*`]);
      }
      if (this.canView('TAG')) {
        filter.push(['PROJECT.TAG.name', 'regex', `(?is).*${this.searchFilter}.*`]);
      }
      if (this.canView('STAGE')) {
        filter.push(['PROJECT.STAGE.name', 'regex', `(?is).*${this.searchFilter}.*`]);
      }
      return filter;
    },
    buildParams({ request: {sortModel, endRow, startRow} }) {
      const self = this;
    
      const params = {
        start: !self.exportData ? startRow : 0,
        limit: !self.exportData ? endRow - startRow + 1 : -1,
      };
      params.ksort = []
      params.order = []
      var ksort = this.filter !== null ? this.filter.sortfield : null;
      if (ksort !== null && ksort.includes('.=')) {
        ksort = transformField(ksort, 'Macro', 'sort');
      }
      
      if (ksort) {
        params.ksort.push(ksort);
        params.order.push(this.filter.sortdirection);
      }
      
      for(let i = 0, len = sortModel.length; i < len; i++) {
        params.ksort.push(sortModel[i].colId === 'progressPercent' ? 'progress' : sortModel[i].colId);
        params.order.push(sortModel[i].sort === 'asc'? 'incr' : 'decr');
      }
      let filter = this.filter !== null ? buildFilter(this.filter.entity, this.filter.query) : null;
      const companyrule = this.companyrule;
      if (companyrule) {
        if (filter === null) {
          filter = [companyrule];
        }
        else {
          filter.push(companyrule);
        }
      }

      if (this.searchFilter !== '') {
        if (!filter) {
          filter = [];
        }
        filter.push(...['_or_', 
          [
            ...this.getFilter()
          ]
        ]);
      }
      
      params.filter = filter;
      
      params.badgeFilters = this.badgeFilters
      
      return params;
    },
    modalOpen(isNew) {
      if(isNew) {
        this.projectId = `PROJECT_NEW_${strRandom(5)}`;
      } else {
        this.projectId = this.selected[0];
      }
      this.projectShow = true;
    },
    projectSuccess(/**payload*/) {
      if (this.tileView) {
        this.listProjects();
      }
      else {
        this.gridApi.refreshServerSide({ purge: true });
      }
    },
    rowDelete() {
      this.confirmDeleteShow = true;
    },
    async confirmDeleteOk(){ 
      this.inProgressShow = true;
      this.inProgressLabel = this.$t('project.progress.deleting');
      const selectedNodes = this.gridApi.getSelectedNodes();
      const toDeleteIdNames = selectedNodes.map(node => { return { uuId: node.data.uuId, name: node.data.name != null? node.data.name : node.data.label } });
      const toDeleteIds = this.selected.map(i => { return { uuId: i } });

      let alertState = alertStateEnum.SUCCESS;
      let alertMsg = this.$t(`project.delete${toDeleteIds.length > 1? '_plural':''}`);
      let alertMsgDetailTitle = null;
      let alertMsgDetailList = [];

      await projectService.remove(toDeleteIds)
      .then(response => {
        if (response.status == 207) {
          alertState = alertStateEnum.WARNING;
          alertMsg = this.$t('project.delete_partial');
          alertMsgDetailTitle = this.$t(`project.error.delete_partial_detail_title${toDeleteIds.length > 1? '_plural' : ''}`);
          const feedbackList = response.data[response.data.jobCase];
          for (let i = 0, len = feedbackList.length; i < len; i++) {
            const feedback = feedbackList[i];
            if (feedback.clue == 'OK') {
              continue;
            }
            const targetId = toDeleteIds[i].uuId;
            const foundObj = toDeleteIdNames.find(item => targetId === item.uuId);
            alertMsgDetailList.push(foundObj != null && foundObj.name != null? foundObj.name : targetId);
          }
        }
      })
      .catch(e => {
        alertState = alertStateEnum.ERROR;
        alertMsg = this.$t(`project.error.delete_failure${toDeleteIds.length > 1? '_plural' : ''}`);
        if (e.response) {
          const response = e.response;
          if (response.status == 422) {
            alertMsgDetailTitle = this.$t(`project.error.delete_partial_detail_title${toDeleteIds.length > 1? '_plural' : ''}`);
            const feedbackList = response.data[response.data.jobCase];
            for (let i = 0, len = feedbackList.length; i < len; i++) {
              const feedback = feedbackList[i];
              if (feedback.clue == 'OK') {
                continue;
              }
              const targetId = toDeleteIds[i].uuId;
              const foundObj = toDeleteIdNames.find(item => targetId === item.uuId);
              alertMsgDetailList.push(foundObj != null && foundObj.name != null? foundObj.name : targetId);
            }
          } else if (403 === response.status) {
            alertMsg = this.$t('error.authorize_action');
          }
          this.scrollToTop();
        }
      });

      if (alertState !== alertStateEnum.ERROR) {
        this.gridApi.refreshServerSide({ purge: true });
      }

      const alertPayload = {
        msg: alertMsg,
        alertState: alertState
      }
      if (alertMsgDetailList.length > 0) {
        alertPayload.details = alertMsgDetailList;
        alertPayload.detailTitle = alertMsgDetailTitle;
      }
      this.inProgressShow = false;
      this.resetAlert(alertPayload);
    },
    openDetail(id, params, data, e){
      this.projectId = id;
      this.renderPopup(e);
      //this.projectShow = true;
    },
    loadColumnSettings(data, columns) {
      if (!columns) {
        return;
      }
      // order the columns based upon the order in 'columns'
      let idx = 0;
      columns.forEach(function(col) {
        const index = data.columnDefs.findIndex((c) => c.field === col.colId);
        if (index !== -1) {
          data.columnDefs.splice(idx++, 0, data.columnDefs.splice(index, 1)[0]);
        }
      });
      
      for (const column of data.columnDefs) {
        const setting = columns.filter(c => c.colId === column.field);
        if (setting.length === 0) {
          column.hide = true;
          column.sort = null; //reset to null to clean up previous view value
          column.sortIndex = null; //reset to null to clean up previous view value
        }
        else {
          column.hide = false;
          column.width = setting[0].width;
          column.sort = setting[0].sort;
          column.sortIndex = setting[0].sortIndex;
        }
      }

      //Rearrange sort Index if necessary
      const columnsWithSortIndex = data.columnDefs.filter(i => i.sortIndex != null);
      if (columnsWithSortIndex.length > 0) {
        columnsWithSortIndex.sort((a, b) => {
          if (a.sortIndex < b.sortIndex) {
            return -1;
          } else if (a.sortIndex > b.sortIndex) {
            return 1;
          }
          return 0;
        })
        
        for (let i = 0, len = columnsWithSortIndex.length; i < len; i++) {
          columnsWithSortIndex[i].sortIndex = i;
        }
      }
      
      if (data != null && data.gridApi != null) {
        data.gridApi.setGridOption('columnDefs', []);
        data.gridApi.setGridOption('columnDefs', data.columnDefs);
        
        data.gridApi.refreshServerSide({ purge: true });
      }

      return false;
    },
    touchStartHandler(e) {
      if('resizer-overlay' == e.target.id) {
        e.preventDefault();
        this.$refs['resizer-overlay'].classList.add('pressed');
        this.$refs['resizer-overlay'].addEventListener('touchmove', this.debouncedTouchMoveHandler);
        this.$refs['resizer-overlay'].addEventListener('touchcancel', this.touchCancelHandler);
        this.$refs['resizer-overlay'].addEventListener('touchend', this.touchEndHandler);
        
        this.touchEvent.isTouchStart = true;
        this.touchEvent.x = e.touches[e.touches.length - 1].clientX;  
        this.touchEvent.leftWidth = this.$refs['lhs-grid'].getBoundingClientRect().width;
      }
    }, 
    touchMoveHandler(e) {
      if(this.touchEvent.isTouchStart) {
        e.preventDefault();
        const dx = e.touches[e.touches.length - 1].clientX - this.touchEvent.x;
        const resizer = this.$refs['resizer'];
        const leftSide = this.$refs['lhs-grid'];
        const rightSide = this.$refs['rhs-chart'];

        const newLeftWidth = (this.touchEvent.leftWidth + dx + this.resizerWidth) * 100 / resizer.parentNode.getBoundingClientRect().width;
        leftSide.style.width = `${newLeftWidth}%`;
        rightSide.style.width = `${100 - newLeftWidth}%`;

        this.toggleSplitterResizeStyle(false);
      }
    }, 
    toggleUserSelect(element, disableSelect) {
      if(disableSelect) {
        element.style.userSelect = 'none';
        element.style.pointerEvents = 'none';
      } else {
        element.style.removeProperty('user-select');
        element.style.removeProperty('pointer-events');
      }
    }, 
    toggleSplitterResizeStyle(state) {
      const leftSide = this.$refs['lhs-grid'];
      const rightSide = this.$refs['rhs-chart'];
      if(state) {
        this.toggleUserSelect(leftSide, true);
        this.toggleUserSelect(rightSide, true);
      } else {
        this.toggleUserSelect(leftSide, false);
        this.toggleUserSelect(rightSide, false);
      }
      
      // save the updated splitter position in the settings
      this.profiles.projectGanttLHSGrid = { width: this.$refs['lhs-grid'].style.width };
      this.profiles.projectGanttRHSChart = { width: this.$refs['rhs-chart'].style.width };
      if (this.updateLayoutProfileTimeout) {
        clearTimeout(this.updateLayoutProfileTimeout);
      }
      this.updateLayoutProfileTimeout = setTimeout(this.updateProjectProfile, 1000);
    }, 
    touchEndHandler(e) {
      if(this.touchEvent.isTouchStart) {
        e.preventDefault();
        this.$refs['resizer-overlay'].classList.remove('pressed');
        this.touchEvent.isTouchStart = false;
        this.$refs['resizer-overlay'].removeEventListener('touchmove', this.debouncedTouchMoveHandler);
        this.$refs['resizer-overlay'].removeEventListener('touchcancel', this.touchCancelHandler);
        this.$refs['resizer-overlay'].removeEventListener('touchend', this.touchEndHandler);
        this.toggleSplitterResizeStyle(false);
      }
    }, 
    touchCancelHandler(/*e*/) {
      if(this.touchEvent.isTouchStart) {
        this.$refs['resizer-overlay'].classList.remove('pressed');
        this.touchEvent.isTouchStart = false;
        this.$refs['resizer-overlay'].removeEventListener('touchmove', this.debouncedTouchMoveHandler);
        this.$refs['resizer-overlay'].removeEventListener('touchcancel', this.touchCancelHandler);
        this.$refs['resizer-overlay'].removeEventListener('touchend', this.touchEndHandler);
        this.toggleSplitterResizeStyle(false);
      }
    }, 
    mouseDownHandler(e) {
      e.preventDefault();
      this.splitterEventState.isMouseDown = true;
      // Get the current mouse position
      this.splitterEventState.x = e.clientX;
      this.splitterEventState.y = e.clientY;
      this.splitterEventState.leftWidth = this.$refs['lhs-grid'].getBoundingClientRect().width;

      // Attach the listeners to `document`
      document.addEventListener('mousemove', this.mouseMoveHandler);
      document.addEventListener('mouseup', this.mouseUpHandler);
    }, 
    mouseMoveHandler(e) {
      e.preventDefault();
      // How far the mouse has been moved
      const dx = e.clientX - this.splitterEventState.x;
      const resizer = this.$refs['resizer'];
      const leftSide = this.$refs['lhs-grid'];
      const rightSide = this.$refs['rhs-chart'];

      const newLeftWidth = (this.splitterEventState.leftWidth + dx + this.resizerWidth) * 100 / resizer.parentNode.getBoundingClientRect().width;
      leftSide.style.width = `${newLeftWidth}%`;
      rightSide.style.width = `${100 - newLeftWidth}%`;
      this.toggleSplitterResizeStyle(true);
    }, 
    mouseUpHandler(e) {
      e.preventDefault();
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener('mousemove', this.mouseMoveHandler);
      document.removeEventListener('mouseup', this.mouseUpHandler);
      this.splitterEventState.isMouseDown = false;
      this.toggleSplitterResizeStyle(false);
    },
    chartResizeHandler: debounce(function(/** e */) {
      const windowHeight = (window.innerHeight > 0) ? window.innerHeight : screen.height;
      const aGContainerElem = this.$refs['aggrid-gantt-container'];
      const offsetTop = aGContainerElem != null? aGContainerElem.offsetTop : 0;
      const _heightOffset = -7;
      let availablePAGContainerHeight = windowHeight - offsetTop - 35 - _heightOffset;
      if (availablePAGContainerHeight < 400) {
        availablePAGContainerHeight = 400;
      }
      if (aGContainerElem != null) {
        aGContainerElem.style.height = `${availablePAGContainerHeight}px`;
      }
      this.$set(this.splitterStyle, 'height', `${availablePAGContainerHeight - 205}px`);
      this.$set(this.lhsGridStyle, 'height', `${availablePAGContainerHeight - 205}px`);

      //use interval to safely access valid $refs component
      const interval = setInterval(() => {
        if(this.$refs['splitter-container']) {
          this.ganttHeight = this.$refs['splitter-container'].clientHeight;
          clearInterval(interval);
        }
      }, 50);
      
    }, 100),
    ganttScrollHandler: debounce(function({ left, top }) {
      this.scrollState.left = left; //Used in keeping previous x position after gantt data refresh
      if( this.scrollState.top != top && !this.scrollState.triggeredByLHSGrid) {
        this.scrollState.triggeredByLHSGrid = false;
        this.scrollState.triggeredByRHSChart = true;
        this.scrollState.top = top;
        if (this.gridApi && this.gridApi.gridBodyCtrl && this.gridApi.gridBodyCtrl.bodyScrollFeature) {
          this.gridApi.gridBodyCtrl.bodyScrollFeature.setVerticalScrollPosition(top);
        }
      } else {
        this.scrollState.triggeredByLHSGrid = false;
        this.scrollState.triggeredByRHSChart = false;
      }
    }, 5),
    createdGantt(gantt) {
      this.gantt = gantt;
      gantt.config.drag_resize = false;
      gantt.config.start_date = moment(this.control.startDate, 'YYYY-MM-DD').toDate();
      gantt.config.end_date = moment(this.control.endDate, 'YYYY-MM-DD').toDate();
    },
    progressComplete() {
      this.inProgressShow = false;
    },
    actionBarDateChanged(dateInStr, { isStartDate=true } = {}) {
      //When user sets startDate and it is later than closeDate, reset closeDate to 1 month later than startDate.
      //When user sets closeDate and it is earlier than startDate, reset startDate to 1 month earlier than closeDate.
      //When user sets startDate 16 year earlier than closeDate, reset startDate to 15 year earlier than closeDate.
      //When user sets closeDate 16 year later than startDate, reset closeDate to 15 year later than startDate.
      let _startDate = null;
      let _closeDate = null;
      if (isStartDate) {
        _startDate = moment.utc(dateInStr, 'YYYY-MM-DD');
        _closeDate = moment.utc(this.control.endDate, 'YYYY-MM-DD');
      } else {
        _startDate = moment.utc(this.control.startDate, 'YYYY-MM-DD');
        _closeDate = moment.utc(dateInStr, 'YYYY-MM-DD');
      }

      //When the date overlaps another date
      if (_closeDate.diff(_startDate) <= 0) {
        if (isStartDate) {
          _closeDate = _startDate.clone().add(1, 'months');
        } else {
          _startDate = _closeDate.clone().subtract(1, 'months');
        }
        
        this.control.startDate = _startDate.format('YYYY-MM-DD');
        this.control.endDate = _closeDate.format('YYYY-MM-DD');
        return;
      }

      //When the range is greater than 15 years
      if (_closeDate.diff(_startDate, 'years') > 15) {
        if (isStartDate) {
          _startDate = _closeDate.clone().subtract(15, 'years');
          this.control.startDate = _startDate.format('YYYY-MM-DD');
          return;
        } else {
          _closeDate = _startDate.clone().add(15, 'years');
          this.control.endDate = _closeDate.format('YYYY-MM-DD');
          return;
        }
      }

      //Default
      if (isStartDate) {
        this.control.startDate = _startDate.format('YYYY-MM-DD');
      } else {
        this.control.endDate = _closeDate.format('YYYY-MM-DD');
      }
    },
    handleControlDates(value) {
      const today = moment();
      if(value != null) {
        this.datesChangeFlag = true;
      }

      if(this.profiles.projectGanttControlDates !== value) {
        this.profiles.projectGanttControlDates = value;
      }

      this.$set(this.control, 'dates', value);
      if ('projects-schedule' === value) {
        let srcStartDate = null;
        let srcCloseDate = null;

        let earliest = null;
        let latest = null;
        const ganttData = this.gantt.serialize();
         // set the colors
        for (var i = 0; i < ganttData.data.length; i++) {
          if (ganttData.data[i].scheduleStart !== 0 &&
              (earliest === null ||
              ganttData.data[i].scheduleStart < earliest)) {
            earliest = ganttData.data[i].scheduleStart;  
          }
          if (ganttData.data[i].scheduleFinish !== 0 &&
              (latest === null || 
              ganttData.data[i].scheduleFinish > latest)) {
            latest = ganttData.data[i].scheduleFinish;  
          }
        }
        srcStartDate = earliest != null? moment(earliest) : null;
        srcCloseDate = latest != null? moment(latest) : null;


        if (srcStartDate == null || srcCloseDate == null) {
          this.profiles.projectGanttControlDates = null;
          this.$nextTick(() => {
            this.$set(this.control, 'dates', null);
          })
          let _startDate = null;
          let _closeDate = null;
          if(srcStartDate == null && srcCloseDate == null) {
            _startDate = today.clone();
            _closeDate = _startDate.clone().add(1, 'months');
          } else if (srcStartDate == null) {
            _closeDate = srcCloseDate;
            _startDate = _closeDate.clone().subtract(1, 'months');
          } else {
            _startDate = srcStartDate;
            _closeDate = _startDate.clone().add(1, 'months');
          }
          this.control.startDate = _startDate.format('YYYY-MM-DD');
          this.control.endDate = _closeDate.format('YYYY-MM-DD');
        }
        else {
          let _startDate = srcStartDate;
          let _closeDate = srcCloseDate;
          if (_closeDate.diff(_startDate, 'years') > 15) {
            this.profiles.projectGanttControlDates = null;
            this.$nextTick(() => {
              this.$set(this.control, 'dates', null);
            });
            _closeDate = _startDate.clone().add(15, 'years');
            
          } 
          this.control.startDate = _startDate.format('YYYY-MM-DD');
          this.control.endDate = _closeDate.format('YYYY-MM-DD');
        }
      }
      else if ('this-week' === value) {
        // Get this week's Monday
        this.control.startDate = today.clone().isoWeekday(1).format('YYYY-MM-DD');
        // Get this week's Friday
        this.control.endDate = today.clone().isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('this-week-to-date' === value) {
        this.control.endDate = today.format('YYYY-MM-DD');
        this.control.startDate = today.clone().isoWeekday(1).format('YYYY-MM-DD');
      } 
      else if ('this-month' === value) {
        this.control.endDate = today.clone().endOf('month').format('YYYY-MM-DD');
        this.control.startDate = today.clone().startOf('month').format('YYYY-MM-DD');
      } 
      else if ('this-month-to-date' === value) {
        this.control.endDate = today.format('YYYY-MM-DD');      
        this.control.startDate = today.startOf('month').format('YYYY-MM-DD');
      } 
      else if ('this-quarter' === value) {
        this.control.startDate = today.clone().startOf('quarter').format('YYYY-MM-DD');
        this.control.endDate = today.clone().endOf('quarter').format('YYYY-MM-DD');
      } 
      else if ('this-quarter-to-date' === value) {
        this.control.startDate = today.clone().startOf('quarter').format('YYYY-MM-DD');
        this.control.endDate = today.format('YYYY-MM-DD');
      } 
      else if ('this-year' === value) {
        this.control.startDate = today.startOf('year').format('YYYY-MM-DD');
        this.control.endDate = today.endOf('year').format('YYYY-MM-DD');
      } 
      else if ('this-year-to-date' === value) {
        this.control.startDate = today.startOf('year').format('YYYY-MM-DD');
        this.control.endDate = today.format('YYYY-MM-DD');
      } 
      else if ('last-week' === value) {
        const lastWeek = today.clone().isoWeek(today.isoWeek() - 1);
        this.control.startDate = lastWeek.isoWeekday(1).format('YYYY-MM-DD');
        this.control.endDate = lastWeek.isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('last-week-to-date' === value) {
        const lastWeek = today.clone().isoWeek(today.isoWeek() - 1);   
        this.control.startDate = lastWeek.isoWeekday(1).format('YYYY-MM-DD');
        this.control.endDate = today.format('YYYY-MM-DD');
      } 
      else if ('last-month' === value) {
        const lastMonth = today.clone().subtract(1, 'months');
        this.control.startDate = lastMonth.startOf('month').format('YYYY-MM-DD');
        this.control.endDate = lastMonth.endOf('month').format('YYYY-MM-DD');
      } 
      else if ('last-month-to-date' === value) {
        this.control.startDate = today.clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.control.endDate = today.format('YYYY-MM-DD');
      } 
      else if ('last-quarter' === value) {
        const lastQuarter = today.clone().subtract(1, 'quarters');
        this.control.startDate = lastQuarter.clone().startOf('quarter').format('YYYY-MM-DD');
        this.control.endDate = lastQuarter.clone().endOf('quarter').format('YYYY-MM-DD');
      } 
      else if ('last-quarter-to-date' === value) {
        this.control.startDate = today.clone().subtract(1, 'quarters').startOf('quarter').format('YYYY-MM-DD');
        this.control.endDate = today.format('YYYY-MM-DD');
      } 
      else if ('last-year' === value) {
        const lastYear = today.clone().subtract(1, 'years');
        this.control.startDate = lastYear.clone().startOf('year').format('YYYY-MM-DD');
        this.control.endDate = lastYear.clone().endOf('year').format('YYYY-MM-DD');
      } 
      else if ('next-week' === value) {
        const nextWeek = today.clone().isoWeek(today.isoWeek() + 1);
        this.control.startDate = today.clone().format('YYYY-MM-DD');
        this.control.endDate = nextWeek.isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('next-4-weeks' === value) {
        today.weekday(1);
        const isTodayFirstDayOfWeek = today.isoWeekday() == 1;
        const next4Weeks = today.clone().isoWeek(today.isoWeek() + (isTodayFirstDayOfWeek? 3 : 4));
        this.control.startDate = today.clone().format('YYYY-MM-DD');
        this.control.endDate = next4Weeks.isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('next-8-weeks' === value) {
        today.weekday(1);
        const isTodayFirstDayOfWeek = today.isoWeekday() == 1;
        const next8Weeks = today.clone().isoWeek(today.isoWeek() + (isTodayFirstDayOfWeek? 7 : 8));
        this.control.startDate = today.clone().format('YYYY-MM-DD');
        this.control.endDate = next8Weeks.isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('next-12-weeks' === value) {
        today.weekday(1);
        const isTodayFirstDayOfWeek = today.isoWeekday() == 1;
        const next12Weeks = today.clone().isoWeek(today.isoWeek() + (isTodayFirstDayOfWeek? 11 : 12));
        this.control.startDate = today.clone().format('YYYY-MM-DD');
        this.control.endDate = next12Weeks.isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('next-24-weeks' === value) {
        today.weekday(1);
        const isTodayFirstDayOfWeek = today.isoWeekday() == 1;
        const next24Weeks = today.clone().isoWeek(today.isoWeek() + (isTodayFirstDayOfWeek? 23 : 24));
        this.control.startDate = today.clone().format('YYYY-MM-DD');
        this.control.endDate = next24Weeks.isoWeekday(7).format('YYYY-MM-DD');
      } 
      else if ('next-month' === value) {
        const nextMonth = today.clone().add(1, 'months');
        this.control.startDate = nextMonth.clone().startOf('month');
        this.control.endDate = nextMonth.clone().endOf('month');
      } 
      else if ('next-quarter' === value) {
        const nextQuarter = today.clone().add(1, 'quarters');
        this.control.startDate = nextQuarter.clone().startOf('quarter').format('YYYY-MM-DD');
        this.control.endDate = nextQuarter.clone().endOf('quarter').format('YYYY-MM-DD');
      } 
      else if ('next-year' === value) {
        const nextYear = today.clone().add(1, 'years');
        this.control.startDate = nextYear.clone().startOf('year').format('YYYY-MM-DD');
        this.control.endDate = nextYear.clone().endOf('year').format('YYYY-MM-DD');
      }
      if (this.datesChangeFlag) {
        //controlDates has been set before.
        this.profiles.projectGanttControlStartDate = this.control.startDate;
        this.profiles.projectGanttControlEndDate = this.control.endDate;
        this.updateProjectProfile();
      }
      
      Vue.nextTick(() => {
        if (this.gantt) {
          this.gantt.render();
        }
        self.datesChangeFlag = false;
      });
    },
    handleDateRange: debounce(function() {
      if(!this.datesChangeFlag) { //If it is not triggered by DatesOpt changed, set control.dates to null.
        this.control.dates = null;
        this.profiles.projectGanttControlDates = this.control.dates;
        this.profiles.projectGanttControlStartDate = this.control.startDate;
        this.profiles.projectGanttControlEndDate = this.control.endDate;
        delete this.profiles.projectStartDate;
        delete this.profiles.projectCloseDate;
        this.updateProjectProfile();
      }
      this.datesChangeFlag = false; //Reset the flag.
      const startDate = this.control.startDate;
      const endDate = this.control.endDate;
      if (!startDate || !endDate || endDate < startDate) {
        return;
      }
      if (this.control.startDate) {
        this.startDate = this.control.startDate;
      }
      if (this.control.endDate) {
        this.endDate = this.control.endDate;
      }
      //Set true to signal dhtmlxGantt vue component to rerender gantt.
      this.$nextTick(() => {
        if (this.gantt && !this.tileView) {
          this.gantt.render();
        }
      });
    }, 100),
    detailLinkIcon(params) {
      if (params.data.avatarRef === "00000000-0000-0000-0000-000000000000") {
        return ['fad','chart-network'];
      }
      return null;
    },
    mobileCheck() {
      let check = false;
      //eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    renderPopup(e, useCoords) {
      this.popupRemoveMenu();
      const target = e.target;
      
      // this function is used by the ag grid list, the tile view and the gantt
      // each have different coordinate issues
      
      let offsetTop = 0;
      let offsetLeft = 0;
      if (this.tileView) {
        offsetTop = e.pageY - (this.canView('TASK') ? 100 : 0);
        offsetLeft = e.pageX - 100;
        if (offsetLeft < 200 && !this.mobileCheck()) {
          offsetLeft = 200;
        }
        
      }
      else if (useCoords) {
        offsetLeft = e.x - 10;
        offsetTop = e.y - 10;
      }
      
      const container = document.getElementById('project_tiles_container');
      const rect = target.getBoundingClientRect();
      const left = this.tileView || useCoords ? offsetLeft : rect.left;
      let top = this.tileView || useCoords ? offsetTop : (rect.top - 180 < -30 ? 0 : rect.top);
      const containerHeight = container.offsetTop + container.offsetHeight;
      // const menuItems = `<div class="staffpopupmenuoption ag-menu-option" tabindex="-1" role="treeitem" aria-level="1" data-action="goto-day">
      //                 <span ref="eIcon" class="ag-menu-option-icon" role="presentation"></span>
      //                 <span ref="eName" class="staffpopupmenutext">${this.$t('staff.overs_timescale_msg')}</span>
      //             </div>`;
      
      const staffUsage = this.canView('STAFF') ? `
        <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="staff_usage">
            <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
            <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.menu.staff_usage') }</span>
            <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
            <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
        </div>` : '';
      const dashboard = this.canView('TASK') ? `
        <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="dashboard">
            <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
            <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.menu.dashboard') }</span>
            <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
            <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
        </div>` : '';
      const tasks = this.canView('TASK') ? `
        <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="tasks">
            <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
            <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.menu.tasks') }</span>
            <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
            <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
        </div>` : '';
      const gantt = this.canView('TASK') ? `
        <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="gantt">
            <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
            <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.menu.gantt') }</span>
            <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
            <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
        </div>` : '';
      const kanban = this.canView('TASK') ? `
        <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="board">
            <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
            <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.menu.board') }</span>
            <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
            <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
        </div>` : '';
      // const resourceUsage = this.canView('TASK') && this.canView('RESOURCE') ? `
      //   <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="resource_usage">
      //       <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
      //       <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.menu.resource_usage') }</span>
      //       <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
      //       <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
      //   </div>` : '';
      const divider = this.canView('TASK') ? `
        <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="none">
            <span ref="eIcon" class="separator-height separator-color ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
            <span ref="eName" class="separator-height separator-color ag-menu-option-part ag-menu-option-text"></span>
            <span ref="eShortcut" class="separator-height separator-color ag-menu-option-part ag-menu-option-shortcut"></span>
            <span ref="ePopupPointer" class="separator-height separator-color ag-menu-option-part ag-menu-option-popup-pointer"></span>
        </div>` : '';
                  
      const htmlContentStr = `
        <div class="projectal-context-menu ag-tabs ag-menu ag-focus-managed ag-ltr ag-popup-child" role="dialog" aria-label="Column Menu">
          
          <div role="presentation" class="ag-tabs-body ag-menu-body">
              <div class="padding-zero ag-menu-list ag-focus-managed" role="tree">
                  <div class="ag-tab-guard ag-tab-guard-top" role="presentation" tabindex="0"></div>
                  <div class="ag-menu-option cursor-pointer" tabindex="-1" role="treeitem" aria-level="1" data-action="edit-project">
                      <span ref="eIcon" class="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
                      <span ref="eName" class="ag-menu-option-part ag-menu-option-text popup-menu-font-size">${ this.$t('project.title_detail') }</span>
                      <span ref="eShortcut" class="ag-menu-option-part ag-menu-option-shortcut"></span>
                      <span ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"></span>
                  </div>
                  ${divider}
                  ${dashboard}
                  ${tasks}
                  ${gantt}
                  ${staffUsage}
                  ${kanban}
                  <div class="ag-tab-guard ag-tab-guard-bottom" role="presentation" tabindex="0"></div>
              </div>
          </div>
      </div>
      `;
      if (this.canView('TASK') &&
          top + 220 > containerHeight) {
        if (this.mobileCheck()) {
          top -= 110;
        }
        else {
          top -= 220;
        }
      }
      const cellMenu = this.htmlToElement(htmlContentStr.trim().replaceAll(/>\n[\s]+/g, '>'));
      cellMenu.style.left = `${left}px`;
      cellMenu.style.top = `${top}px`;
      let popupElement = null;
      popupElement = document.createElement('div');
      popupElement.classList.add('ag-theme-balham')
      popupElement.classList.add('ag-popup');
      popupElement.classList.add('header-group-column-popup');
      popupElement.appendChild(cellMenu);
      document.querySelector('#project_tiles_container').appendChild(popupElement);

      //Register events for menu options      
      const menuOptions = cellMenu.querySelectorAll('.ag-menu-option');
      if (menuOptions != null) {
        for (let i = 0, len = menuOptions.length; i < len; i++) {
          //'Click'
          menuOptions[i].addEventListener('click', this.handleMenuOptionClick);
          //'Mouseenter' and 'Mouseleave'
          menuOptions[i].addEventListener('mouseenter', this.addMenuOptionHighlight);
          menuOptions[i].addEventListener('mouseleave', this.removeMenuOptionHighlight);
        }
      }

      //Register event for hiding menu when clicking outside of menu
      this.clickOutsideEventHandler = function(e) {
        const popupElem = document.querySelector('.header-group-column-popup');
        if (popupElem != null) {
          if (!popupElem.contains(e.target)) {
            popupElem.remove();
          }
        }
      }
      document.addEventListener('mousedown', this.clickOutsideEventHandler);
      
      this.popupElement = popupElement;
      popupElement.addEventListener('mouseleave', this.popupRemoveMenu);
    },
    popupRemoveMenu() {
        
      // if (this.popupElement) {
      //   this.popupElement.removeEventListener('mouseleave', this.popupRemoveMenu);
      //   this.popupElement.remove();
      //   delete this.popupElement;
      // }
      
    },
    handleMenuOptionClick(event) {
      const menuOption = event.target.closest('.ag-menu-option');
      const action = menuOption.dataset.action;
      if (action == 'edit-project') {
        this.projectShow = true;
      } else if (action == 'dashboard') {
        this.$router.push(`/projects/summary/${this.projectId}`);
      } else if (action == 'tasks') {
        this.$router.push(`/projects/tasks/${this.projectId}`);
      } else if (action == 'gantt') {
        this.$router.push(`/projects/gantt/${this.projectId}`);
      } else if (action == 'staff_usage') {
        this.$router.push(`/projects/staff/${this.projectId}`);
      } else if (action == 'resource_usage') {
        this.$router.push(`/projects/resource/${this.projectId}`);
      } else if (action == 'board') {
        this.$router.push(`/projects/kanban/${this.projectId}`);
      }
      this.cleanUp();
    },
    addMenuOptionHighlight(event) {
      const menuOption = event.target.closest('.ag-menu-option');
      const activeClass = 'ag-menu-option-active';
      if (!menuOption.classList.contains(activeClass)) {
        menuOption.classList.add(activeClass);
      }
    },
    removeMenuOptionHighlight(event) {
      const menuOption = event.target.closest('.ag-menu-option');
      const activeClass = 'ag-menu-option-active';
      if (menuOption.classList.contains(activeClass)) {
        menuOption.classList.remove(activeClass);
      }
    },
    htmlToElement(html) {
      var template = document.createElement('template');
      html = html.trim(); // Never return a text node of whitespace as the result
      template.innerHTML = html;
      return template.content.firstChild;
    },
    handleMenuHeaderClick(/* event */) {
      this.cleanUp();
    },
    cleanUp() {
      if (this.clickOutsideEventHandler != null) {
        this.clickOutsideEventHandler({ target: null });
        document.removeEventListener('mousedown', this.clickOutsideEventHandler);
        this.clickOutsideEventHandler = null;
      }
    },
    taskSelectionChangedHandler(payload) {
      this.processTaskSelectionChangedList(payload)
    }, 
    processTaskSelectionChangedList(pList) {
     
      const api = this.gridApi;
      if (api == null) {
        return;
      }

      //Remove the task id which is already included in taskSelectionIds and it's state is true.
      //Reason: User clicks a non-autoGridColumn cell in LHS grid and this event is triggered indirectly. It is not intended. So the logic helps break the flow.
      let pendingList = pList.filter(i => !(this.taskSelectionIds.includes(i.id) && i.state == true));
      if (pendingList.length < 1) {
        return;
      }

      let hasRowNodeNull = false;
      //Get the rowIndex based on the provided (task) id.
      for (const p of pendingList) {
        const rNode = api.getRowNode(p.id);
        if (rNode == null) {
          hasRowNodeNull = true;
          break;
        }
        p.rowIndex = rNode.rowIndex;
      }

      //Defensive code: Stop proceed further when the rowNode is null
      if (hasRowNodeNull) {
        return;
      }

      //Sort in ascending order
      pendingList.sort(( a, b ) => {
        if (a.rowIndex == null && b.rowIndex == null) {
          return 0;
        }
        if (b.rowIndex == null || a.rowIndex < b.rowIndex){
          return -1;
        }
        if (a.rowIndex == null || a.rowIndex > b.rowIndex){
          return 1;
        }
        return 0;
      });

      //Get the existing cell ranges if there is any
      let cellRanges = api.getCellRanges();
      if (cellRanges == null) {
        cellRanges = [];
      }
      //Preprocess the cell range data to extract the needed information.
      cellRanges = cellRanges.map(i => {
        return {
          rowStartIndex: i.startRow.rowIndex < i.endRow.rowIndex? i.startRow.rowIndex : i.endRow.rowIndex
          , rowEndIndex: i.startRow.rowIndex < i.endRow.rowIndex? i.endRow.rowIndex : i.startRow.rowIndex
          , columns: i.columns.map(j => j.colId)
        }
      });
      
      const excludeFromCellRanges = (pendingList, cellRanges) => {
        let _cRanges = objectClone(cellRanges);
        let processedRanges = [];
        for (const row of pendingList) {
          for (const cRange of _cRanges) {
            if (cRange.rowStartIndex == row.rowIndex && cRange.rowEndIndex == row.rowIndex) {
              continue; //Continue to next iteration when current range contains only single row and it matches the current row.
            }
            if (row.rowIndex < cRange.rowStartIndex || row.rowIndex > cRange.rowEndIndex) {
              processedRanges.push(cRange);
              continue; //Register current range and continue to next iteration when the current row is not in the range.
            }
            //Split range to exclude the current row
            //Rows before the current row.
            if (cRange.rowStartIndex < row.rowIndex) {
              processedRanges.push({
                rowStartIndex: cRange.rowStartIndex
                , rowEndIndex: row.rowIndex - 1
                , columns: cRange.columns
              });
            }
            //Rows after the current row.
            if (cRange.rowEndIndex > row.rowIndex) {
              processedRanges.push({
                rowStartIndex: row.rowIndex + 1
                , rowEndIndex: cRange.rowEndIndex
                , columns: cRange.columns
              });
            }
          }
          _cRanges = processedRanges; //Sync latest change and ready for next iteration.
          processedRanges = []; //Reset value and ready for next iteration.
        }
        return _cRanges;
      }

      const addToCellRanges = (toSelectList, cellRanges) => {
        let _cRanges = objectClone(cellRanges);
        let processedRanges = [];
        let beforeRange, afterRange;
        for (const selected of toSelectList) {
          beforeRange = null;
          afterRange = null;
          let found;
          for (const cRange of _cRanges) {
            found = false;
            //Loop thru all the ranges to find the ranges with only autoGroupColumn and are right before or after the current row.
            if (cRange.columns.length == 1 && cRange.columns[0] == this.COLUMN_AGGRID_AUTOCOLUMN) {
              if (cRange.rowStartIndex - 1 == selected.rowIndex) {
                found = true;
                afterRange = cRange;
              } else if (cRange.rowEndIndex + 1 == selected.rowIndex) {
                found = true;
                beforeRange = cRange;
              }
            }
            if (!found) {
              processedRanges.push(cRange);
            }
          }

          //Combine those ranges into one with help of current row.
          let newRowStartIndex = selected.rowIndex;
          let newRowEndIndex = selected.rowIndex;
          if (beforeRange != null) {
            newRowStartIndex = beforeRange.rowStartIndex;
          } 
          if (afterRange != null) {
            newRowEndIndex = afterRange.rowEndIndex;
          }
          
          processedRanges.push({
            rowStartIndex: newRowStartIndex
            , rowEndIndex: newRowEndIndex
            , columns: [this.COLUMN_AGGRID_AUTOCOLUMN]
          });
          _cRanges = processedRanges; //Sync latest change and ready for next iteration.
          processedRanges = []; //Reset value and ready for next iteration.
        }
        return _cRanges;
      }

      //Remove all the affected rows (either selected or unselected) from cellRanges
      cellRanges = excludeFromCellRanges(pendingList, cellRanges);

      //Add the newly selected row to the cellRanges
      cellRanges = addToCellRanges(pendingList.filter(i => i.state == true), cellRanges);

      api.clearRangeSelection();
      for (const ncRange of cellRanges) {
        api.addCellRange(ncRange);
      }
    }, 
    updateFocusedCell(id) {
      let api = this.gridApi;
      if (api == null || id == null) {
        return;
      }
      const rNode = api.getRowNode(id);
      if (rNode == null || rNode.rowIndex == null) {
        return;
      }
      
      rNode.setSelected(true);
      api.clearFocusedCell();
      api.setFocusedCell(rNode.rowIndex, this.COLUMN_AGGRID_AUTOCOLUMN, null);
    }, 
    taskClickedHandler(id, e, parentComponent) {
      this.updateFocusedCell(id);
      if (e.target.classList.contains('gantt_task_content') ||
          (e.target.parentElement && 
          e.target.parentElement.classList.contains('gantt_task_content'))) {
        this.projectId = id;
        this.renderPopup(e, true);
        const tooltipObj = parentComponent != null && parentComponent.taskTooltip != null? parentComponent.taskTooltip : null;
        if (tooltipObj) {
          tooltipObj.show = false;
        }
      }
    }, 
    taskCellFocusedHandler(id) {
      this.updateFocusedCell(id);
    },
    markerStateHandler(state, key) {
      this.marker[key] = state;
      this.profiles[`ganttMarker_${key}`] = state;
      this.updateProjectProfile();
    },
    onInfoOver(index) {
      profileService.nodeList(this.projectViews[index].uuId).then((response) => {
        this.projectViews[index].owner = response.data.resultList.filter(v => this.projectViews[index].editingPermissions.includes(v.uuId)).map(r => { return r.name }).join(", ");
        this.$set(this.showInfo, index, true);
      });
    },
    onInfoLeave(index) {
      this.$set(this.showInfo, index, false);
    },
    getDurationConversionOpts() {
      return this.$store.dispatch('data/configSchedule').then(value => {
        this.durationConversionOpts = extractDurationConversionOpts(value);
      })
      .catch(e => {
        console.error(e); //eslint-disable-line no-console
      });
    },
    isEllipsisActive(text) {
      return isEllipsisActive(text, this);
    },
    async loadProfiles() {
      // load the profiles in order so that we get the layout profile with the uuId first
      // then we can update it with the view profile if loaded by URL
      await this.listProjectProfiles();
      this.loadUserProfile(); // User profile holds project views  
      this.loadPublicProfile(); // Public profile holds public project views
      
    },
    onFilterOver() {
      if (this.$refs?.filter != null) {
        this.$refs.filter.visible = true;
      }
    },
    onFilterLeave() {
      if (this.$refs?.filter != null) {
        this.$refs.filter.visible = false;
      }
    },
    onFilterSubmit() {
      this.filterTextFocus = false;
      if (this.$refs?.filter != null) {
        this.$refs.filter.visible = false;
      }
      this.closePriorityNavDropdown = true; //Signal priorityNavigation to close the dropdown.
      
      this.changeFilter(this.filterText);
    },
    onFilterClear() {
      this.filterText = '';
      this.changeFilter(this.filterText);
    },
    changeFilter: debounce(function(value, updateProfile=true) {
      const hasFilterValueChanged = this.searchFilter == value;
      this.searchFilter = value;
      if (updateProfile) {
        this.profiles.projectSearchValue = value;
        this.updateProjectProfile({ clearViewName: hasFilterValueChanged });
      }
            
      if (this.gridApi == null) {
        return;
      }
      
      if (!this.tileView && this.gridApi && !this.gridApi.isDestroyed()) {
        this.gridApi.refreshServerSide({ purge: true });
      } 
    }, 100),
    onFilterTextDropdownHide(bvEvent) {
      if(this.filterTextFocus){
        bvEvent.preventDefault();
      }
    },
    onPinFilter() {
      this.filterPinned = true;
      this.profiles.filterPinned = this.filterPinned;
      this.updateProjectProfile();
    },
    onUnPinFilter() {
      this.forcePriorityNavRefresh = true;
      this.filterPinned = false;
      this.profiles.filterPinned = this.filterPinned;
      this.updateProjectProfile();
    },
    onBadgeFilterModified(filter) {
      this.badgeFilterFocus = true; //Pin the badgeFilter when a change is made.
      const removedFilterFields = this.badgeFilters.filter(i => filter.find(j => j.field == i.field) == null).map(i => i.field);
      this.badgeFilters = filter;
      
      for (const f of filter) {
        if (Object.hasOwn(this.badgeFilterFieldValues, f.field)) {
          if (Array.isArray(f.value) && f.value.length > 0) {
            this.badgeFilterFieldValues[f.field].forEach(i => {
              i.checked = f.value.find(j => j.text.localeCompare(i.text, undefined, { sensitivity: 'base' }) == 0) != null;
            });
          } else {
            if (Array.isArray(f.value) && f.value.length > 0) {
              this.badgeFilterFieldValues[f.field].forEach(i => {
                if (i.checked) {
                  i.checked = false;
                }
              });
            }
          }
        }
      }
      //reset checked state for the previously selected but now removed filter
      if (removedFilterFields.length > 0) {
        for (const f of removedFilterFields) {
          if (Object.hasOwn(this.badgeFilterFieldValues, f)) {
            if (Array.isArray(this.badgeFilterFieldValues[f])) {
              this.badgeFilterFieldValues[f].forEach(i => {
                if (i.checked) {
                  i.checked = false;
                }
              });
            }                     
          }
        }
      }
      this.badgeFilterFieldValues = JSON.parse(JSON.stringify(this.badgeFilterFieldValues)); //Force triggering vue reactivity
      this.profiles['projectsBadgeFilter'] = filter;
      this.clearProjectSettings();
      this.changeFilter(this.filterText);
    },
    onAdvFilterModified(filter) {
      this.badgeFilters = [{ name: 'Advanced', type: 'advanced' }];
      this.filter = filter;
      if (this.tileView) {
        this.listProjects();
      }
      else {
        this.gridApi.refreshServerSide({ purge: true });
      }
    },
    onBadgeFilterDropdownHide(bvEvent) {
      if (this.badgeFilterFocus || this.badgeFilterModalOpened != 'close') {
        bvEvent.preventDefault();
      }
    },
    onBadgeFilterEnter() {
      this.$refs.badgeFilter.visible = true;
    },
    onBadgeFilterOver(evt) {
      if (this.$refs.badgeFilter?.$el.id != null && evt.target.closest('.dropdown-toggle') != null && this.badgeFilterModalOpened != 'open' && this.badgeFilterFocus) {
        const id = evt.target.closest('.dropdown-toggle').id;
        if (id != null && id.startsWith(this.$refs.badgeFilter?.$el.id)) {
          this.badgeFilterFocus = false; 
        }
      }
    },
    onBadgeFilterLeave() {
      if (!this.badgeFilterFocus && this.$refs?.badgeFilter != null) {
        this.$refs.badgeFilter.visible = false;
      }
    },
    onBadgeFilterModalOpened() {
      this.badgeFilterModalOpened = 'open';
      this.badgeFilterFocus = true;
    },
    onBadgeFilterModalClosed() {
      this.badgeFilterModalOpened = 'signaled-close';
    },
    toggleBadgeFilterFocus(evt) {
      if (this.badgeFilterModalOpened == 'signaled-close') {
        this.badgeFilterModalOpened = 'close';
      } else if (this.badgeFilterFocus && this.badgeFilterModalOpened == 'close' && (this.$refs?.badgeFilter?.$el?.id == null || evt.target.closest(`#${this.$refs.badgeFilter.$el.id}`) == null)) {
        this.badgeFilterFocus = false;
      } else if (!this.badgeFilterFocus && this.$refs?.badgeFilter?.$el?.id != null &&evt.target.closest(`#${this.$refs.badgeFilter.$el.id}`) != null) {
        this.badgeFilterFocus = true;
      }
    },
    handleBadgeFilterEscapeKeyDown(e) {
      const evt = e || window.event;
      if (evt.keyCode === 27 && this.badgeFilterFocus) {
        this.badgeFilterFocus = false;
        this.badgeFilterModalOpened = 'close';
        this.closePriorityNavDropdown = true;
      }
    },
    onPinBadgeFilter() {
      this.badgeFilterPinned = true;
      this.profiles['projectsBadgeFilterPinned'] = this.badgeFilterPinned;
      this.updateProjectProfile();
    }, onUnPinBadgeFilter() {
      this.forcePriorityNavRefresh = true;
      this.badgeFilterPinned = false;
      this.profiles['projectsBadgeFilterPinned'] = this.badgeFilterPinned;
      this.updateProjectProfile();
    }, 
    async onBadgeFilterFetchOptions(payload) {
      if (this.badgeFilterOptionFetchFunc != null) {
        const values = await this.badgeFilterOptionFetchFunc(payload.field).then(data => {
          return data;
        })
        .catch(e => {
          console.error(e) //eslint-disable-line no-console
          return [];
        });
        
        this.$set(this.badgeFilterFieldValues, payload.field, values);
      } else {
        this.badgeFilterFieldValues[payload.field] = []
      }
    }, 
    initSingleBadgeFilterValues() {
      const singleValues = ['startTime',
                            'closeTime',
                            'progress',
                            'description'
                           ];
                         
      // these value are single values to be entered by the user
      for (const val of singleValues) {
        this.badgeFilterFieldValues[val] = null;
      }     
    },
  }
};
</script>

<style>
.loading {    
  width: 35px;
  margin: auto;
  margin-top: 25%;
}

.project-tile {
  float: left;
  margin: 1px;
  margin-bottom: 1.5rem;   
  margin-right: auto;  
  margin-left: auto;  
  border-radius: 6px;
  max-width: 290px;
  min-width: 290px;
  cursor: pointer;
  box-shadow: var(--surface-shadow);
}

.project-tile-none {
  background-color: #00d5ff;
}

.project-tile-0 {
  background-color: var(--progress-0);
}

.project-tile-25 {
  background-color: var(--progress-25);
}

.project-tile-50 {
  background-color: var(--progress-50);
}

.project-tile-75 {
  background-color: var(--progress-75);
}

.project-tile-99 {
  background-color: var(--progress-99);
}

.project-tile-100 {
  background-color: var(--progress-100);
}

.link:hover {
  text-decoration: none;
}

.project-title {
  position: relative;
  bottom: 0;
  color: var(--text-on-dark);
  text-align: center;
  font-weight: bold;
  padding: 8px 4px;
  font-size: 1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fav-background {
  padding-top: 20px;
  background-color: var(--backdrop);
  box-shadow: var(--surface-shadow);
  border-radius: 4px;
  gap: 5px;
}

.project-controls {
  display: flex; 
  justify-content: flex-end;
  margin-bottom: 0;
  height: 40px;
  font-size: 18px;    
  position: relative;
  top: -10px;
}

.filter-button,
.visibility-button,
.clear-filter-button {
  margin-top: 7px;
  cursor: pointer;
}

.project-attribute-toggler {
  display: inline-block;
}

.project-attribute-toggler .btn {
  font-size: 18px;
  color: var(--grid-toolbar-button);
}
.project-attribute-toggler .dropdown ul {
  margin-top: 0;
}

.search-container {
  display: flex;
  margin-top: 2px;
}

.search-field {
  flex-grow: 1;
  display: inline-block;
}

.search-group {
  height: 35px;
}

.search-clear {
  color: var(--white);
}

.switch-container {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}

.project-list-switch {
  font-size: 14px;
}

@media only screen and (max-width: 768px) {
  .project-switch-label {
    display: none;
  }
}

.hidden-message {
  width: 200px;
  margin: auto;
  text-align: center;
  font-size: 25px;
  margin-top: 15%;
}

.hidden-message-text {
  font-size: 14px;
}

.project-list {
  padding-top: 10px;
}

.project-list .row {
  gap: 5px;
}

.legend-item {
  height: .8em;
  width: .8em;
  display: inline-block;
  margin-right: .8em;
}

.projectlist-grid-height {
    height: calc(100vh - 205px);
    min-height: 150px;
}
.resizer {
  position: relative;
  background-color: var(--border-dark);
  cursor: ew-resize;
  height: 100%;
  width: 5px;
}

.splitter-container {
  width: 100%;
  height: 64px;
  display: flex;
  margin-bottom: 20px;
  height: calc(100vh - 330px);
}

.lhs-grid {
  justify-content: center;
  align-items: center;
  width: 25%;
  height: 100%;
}

.rhs-chart {
  justify-content: center;
  align-items: center;
  width: calc(75% - 5px);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border: solid 1px var(--ag-border-color);
}

.project-attribute-toggler .dropdown-menu {
  max-height: 600px;
}

.separator-color {
  border-bottom: 1px solid var(--ag-border-color);
}

.separator-height {
    line-height: 5px !important;
    padding: 0 !important;
}

#project-grid .ag-body-viewport.ag-layout-normal::-webkit-scrollbar {
  display: none;
}
#project-grid .ag-body-viewport.ag-layout-normal {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.popup-menu-font-size {
  font-size: 14px;
}

.padding-zero {
  padding: 0 !important;
}

.projects-priority-nav {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.projects-priority-nav-ul {
  display: flex !important;
  margin-bottom: 0;
  align-items: center;
}

.no-left-padding .dropdown-menu .dropdown-item {
  padding: 4px 0;
}

.projectal-context-menu .ag-menu-option-active {
  background-color: var(--dropdown-hover-bg);
}

.projecttile-lhs-default-cell {
  line-height: 33px;
}

.ag-menu-body {
  background-color: var(--ag-background-color);
}

.action-bar-dropdown.view-btn .dropdown-menu {
  left: -150px;
}
.action-bar-dropdown.coloring-btn .dropdown-menu {
  left: -72px;
}
.project-attribute-btn .dropdown-menu {
  left: -108px;
}
.project-tiles.grid-toolbar {
  height: 42px;
}
.project-tiles.grid-toolbar .display-settings .dropdown-item.progress-toggle {
  padding-left: 16px;
}
.project-tiles.grid-toolbar .active-check {
  position: absolute;
  right: 10px;
  top: 8px;
}
.project-tiles.toolbar-bottom-gap {
  margin-bottom: 16px;
}
</style>
